import { Component, OnInit, ViewRef, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IomService } from 'src/app/services/iom.service';
import { Location } from '@angular/common';
import { DeepDiveDetails } from 'src/app/models/DeepDiveDetails';
import { HttpErrorResponse } from '@angular/common/http';
import { SessionService } from 'src/app/services/session.service'
import { MessageService } from 'src/app/services/message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BtInsightService } from 'src/app/services/charts.service';
import { AppConfigService } from 'src/app/services/app-config.service';
import { timeout } from 'rxjs/operators';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
declare var userNotification: any;
declare var $: any;
declare var bootbox: any;
//const removeElements = (elms) => elms.forEach(el => el.remove());
@Component({
  selector: 'app-deep-dive',
  templateUrl: './deep-dive.component.html',
  styleUrls: ['./deep-dive.component.css'],

  styles: [`
    .container {
      height: 30px;
      overflow: hidden;
      position: relative;
      width: 100%;
    }

    .scrolling-text {
      position: absolute;
      white-space: nowrap;
    }

    /* Below doesn't work to pause */

    .scrolling-text:hover, .container:hover {
      -moz-animation-play-state: paused;
      -webkit-animation-play-state: paused;
      animation-play-state: paused;
    }
  `],
  animations: [
    trigger('scroll', [
      state('on', style({left: '-100px'})),
      transition('* => *', [
        style({left: '-100px'}),
        animate(50000, style({left: '100%'}))
      ])
    ])
  ]
})
export class DeepDiveComponent implements OnInit {
  treemapSummary: string = "treemapSummary";
  ExpandTreemap: boolean = false;
  treesummary_expand: string = "treesummary_expand";
  proposalId: Number;
  blob: Blob;
  DeepDiveDetails: DeepDiveDetails = new DeepDiveDetails();
  DeepDiveData: DeepDiveDetails[];
  DeepDiveDataFiltered: any;
  DeepDiveDataFiltered1: any;
  DistinctStatusList: string[];
  CatSubcatData: any;
  classifyBy: string;
  InsightBy: string;
  VersionId: number;
  qpversionId: string;
  VersionIdMongo: string;
  qpddname: string;
  searchValue: any
  ddDataLength: number;
  envData: any;
  timeInterval: any;
  scrolltimeInterval: any;
  otherSearch = false;
  otherSearch1 = false;
  selectedDate1: string;
  selectedDate2: string;
  isLoadDeepdive = true;
  isLoadReview = false;
  isLoadTrend = false;
  isLoadText = false;
  isLoadDQT = false;
  isProceed = false;  
  userType: number;
  CategorisedTicketcount: number;
  TicketPercentage: number;
  TextcategoryOrSubcategoryName: any = null;
  TextTicketCount: any = 0;
  displayExpandTreeMap: boolean = false;
  ActiveCat: any = null;
  ActiveSubcat: any = null;
  InactiveDD: boolean = false;
  observationText: string;
  Isselected1: boolean = false;
  Isselected2: boolean = false;
  Isselected3: boolean = false;
  Isselected4: boolean = false;
  Isselected5: boolean = false;
  Isselected6: boolean = false;
  Isselected7: boolean = false;
  Isselected8: boolean = false;
  Isselected9: boolean = false;
  magicNumber: number = 0;
  startdate: string;
  enddate: string;
  startdatechecker: string;
  enddatechecker: string;
  showcharts: boolean = false;
  activeinactiveddtext: string;
  autoRefresh: any;
  expandDD: string;
  isDisabled: boolean = false;
  displayCal: boolean = false;
  displayFilter: boolean = false;
  deepDivestatus: string;
  spinshow: boolean = false;
  showDDTicketType : boolean = false; 

  //DQT Filters declarations
  //myForm: FormGroup;
  disabled = false;
  // ShowFilter = false;
  limitSelection = true;
  selectedItems: any = [];
  dropdownSettings: any = {};
  public lstFilterResponse = [];
  public lstFilterResponse_pre: any;
  loadoldFilter: boolean = true;
  public lstSelectedFilterVals = [];
  public lstSelectedFilterVals_pre: any;
  @ViewChild('filterPopup') filterPopupId: ElementRef;
  DQTFilterDetails: any = null;
  IsFilterModified: boolean = false;
  DQTFilterKeys: any = null;
  ClearFiltersFlag: boolean = false;
  loadDoughnut: boolean = false;
  CategorizedPercentage: number;
  keyChartGraphData: any;
  keyChartGraphDataExpended: any;
  keyChartsRowrankings: number[];
  rowRankwiseDataKey: any;
  keyChartTitleList: any;
  pareto_expand: string = "pareto_expand";
  public topSelection: number = 20;
  activefilter: boolean;
  ddFilter: boolean = true;
  ddExport: boolean = true;
  dqtAutomate: boolean = true;
  startdate1: string;
  enddate1: string;
  newstatus: boolean = false;
  newstatus1: boolean = false;
  dqtStatus: boolean = false;
  disfilter: boolean = false;
  wordreset: boolean = false;
  disclaimer: boolean;
  VersionIdMongoupdated: string;
  newflag: boolean = true;
  nocallddtiles: string = 'false'
  filterEnabler: boolean = true;
  exportEnabler: boolean = true;
  enableDQT: boolean = true;
  IsLemmaEnabled: boolean = true;
  DDStartDate: any;
  DDEndDate: any;
  DDTicketType: any;
  DDClassificationBasedOn: any;
  DDAlgorithm: any;
  prevactiveddtext: string;
  isDisabledLanguage: boolean = false;
  selectedLanguage = [];
  selectedStdLanguage : string;
  dropdownSettingsLanguage = {};
  LanguageList: any;
  isdataAvailable: boolean = false;

  startTime: string;
  endTime: string;
  downTimeDate: string;
  state = 0;
  downTime: any[];

  scrollDone() {
    this.state++;
  }
  
  constructor(private appConfigService: AppConfigService, private spinner: NgxSpinnerService, private router: Router, private location: Location, private messageService: MessageService, public iomservice: IomService, public sessionservice: SessionService, private route: ActivatedRoute, private chartService: BtInsightService,
  ) {
    this.envData = this.appConfigService.getEnvironment();
    this.timeInterval = this.envData.timeInterval;
    this.scrolltimeInterval = this.envData.scrolltimeInterval;
    this.keyChartsRowrankings = this.envData.keyRowRankings.split(',');
  }
  TotalTicketCountLabel: number;
  E2EUId: string;
  WSUId: string;
  CMSUId: string;
  solutionId: number;
  setInterval = setInterval;
  selectedTileName = '';
  ddlabel: string;
  selectedStatus = 'All';
  searchText = '';
  completedDeepDive: any;
  setId: any;
  NoDataCat: boolean = false;
  NoDataKey: boolean = false;

  ngOnInit() {
    window.addEventListener('ModalClosed', () => {
      this.exportDeepdive();
    })
    // var Reload = this.sessionservice.getSessionStorageItem('ReloadNewProposal');
    // if(Reload=='True')
    // {
    //   this.sessionservice.setSessionStorageItem("ReloadNewProposal", "False");
    //   window.location.reload()
    // }

    if(sessionStorage.getItem("NewProposal") == "True")
    {
      this.sessionservice.setSessionStorageItem("NewProposal", "false");  
      this.LoadNewProposalScope(sessionStorage.getItem("selectedProposalId"));
    }

    if(this.envData.EnableDownTime){
      this.downTime = this.envData.DownTime.split(',');
      this.downTimeDate = this.downTime[0];
      this.startTime = this.downTime[1];
      this.endTime = this.downTime[2];
    }
    this.displayExpandTreeMap = false;
    //Query String for DeepDive Page, When DDname and Version ID is provided, Routed to the DeepDive summary Page
    this.route.queryParams.subscribe(params => {
      this.VersionIdMongo = params['VersionId']; // + is for converting the string to number
      this.ddlabel = params['DDName'];
      this.qpversionId = this.VersionIdMongo;
      this.qpddname = this.ddlabel;
      localStorage.removeItem('VersionId');
      localStorage.removeItem('CategoryId');
      localStorage.removeItem('SubCategoryId');
      sessionStorage.removeItem('VersionId');
    });

    this.dropdownSettings = {
      // singleSelection: false,
      idField: 'DimensionValue',
      textField: 'DimensionValue',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };

    //Check whether bookmarked DD is in active or inactive state.
    if (this.iomservice.isactivedeepdive) {
      this.DeepDiveDetails.ShowHide = true;
    }
    else {
      this.DeepDiveDetails.ShowHide = false;
      this.InactiveDD = true;
      document.getElementById('activedd').classList.remove('active');
      document.getElementById('inactivedd').classList.add('active');
    }
    $(window).scroll(function () {
      if ($('.myw-topbar').length) { // element exists)
        if ($(this).scrollTop() >= $('.myw-topbar').offset().top) {
          $('body').addClass('myw-sticky');
          //$('body').removeClass('iom-left-scroll')
        }
        else {
          $('body').removeClass('myw-sticky');
        }
      }
      else
        $('body').removeClass('myw-sticky');
    }).trigger('scroll');

    /* Try Now */
    $('.iom-try-now').click(function(){
      $(this).parents('.iom-try-now-section').addClass('open');
            });
    $('.iom-try-close').click(function(){
      $(this).parents('.iom-try-now-section').removeClass('open');
            });
    //iom Left Panel
    $('.iom-list-item').click(function (e) {
      e.preventDefault();
      $('.iom-list-item').removeClass('active');
      $(this).addClass('active');
    });

    $('.iom-datepicker').click(function (e) {
      e.preventDefault();
    });
    //IOM Sticky
    //var sdtop = $('.iom-side-menu-section').offset().top;
    var sdtop = 200;
    $(window).scroll(function () {
      if ($(this).scrollTop() >= sdtop) {
        $('.iom-side-menu-section').addClass('iom-menu-sticky');
        //$('.iom-side-menu-section1').addClass('iom-left-scroll');
        // $('.iom-list').css('overflow-y: hidden');
        // $('.iom-list').css('overflow-x: hidden');
      }
      else {
        $('.iom-side-menu-section').removeClass('iom-menu-sticky');
        //$('.iom-side-menu-section1').addClass('iom-left-scroll');
        // $('.iom-list').css('overflow-y: auto');
        // $('.iom-list').css('overflow-x: auro');
      }
    }).trigger('scroll');
    //perfect scrollbar
    // var containers = document.querySelectorAll('.contentHolder');
    // new PerfectScrollbar(containers[0]);
    //IOM Edit & Refresh
    $(".iom-navbar-tab").hide();
    $('.iom-card.imo-card-edit').hover(function () {
      $(".iom-navbar-tab").show();
    });
    $(".dis-img").hide();
    $(".topgraph-dis").hide();
    $(".selet-disabled").hide();
    $('.ena-img').click(function () {
      $(".dis-img").show();
    });
    $(document).ready(function () {
      $(".myw-scope .dropdown-menu").click(function (e) {
        e.stopPropagation();
      });
      $("#SelectAllInsights").click(function () {
        $(".chkEbox").prop('checked', $(this).prop('checked'));
      });
    });
    
    let that = this;
    if (this.envData.Env == "SAAS_ManualUpload") {   
      var getDDLen =  this.qpddname == undefined || "" ? 0 :  this.qpddname.split('(').length 
      if(sessionStorage.getItem("Instance") == "SAAS" || getDDLen == 2){
        this.sessionservice.setSessionStorageItem("userType", "3");  
        sessionStorage.setItem("Instance", 'SAAS');
      }  
      else{                
        this.sessionservice.setSessionStorageItem("userType", "1");  
        sessionStorage.setItem("Instance", 'PAM');
      }               
    }
    this.proposalId = parseInt(this.sessionservice.getSessionStorageItem('selectedProposalId'));
    this.userType = parseInt(this.sessionservice.getSessionStorageItem('userType'));
    this.messageService.subj.subscribe(msg => {
      if ((this.userType == 1 && this.envData.Env == "FDS_ManualUpload")) {
        that.proposalId = msg;
        if (sessionStorage.getItem("Instance") != "PAM") 
        {
          that.sessionservice.removeSessionValue("e2EUId");
        }
        that.sessionservice.removeSessionValue("cMSUID");
        that.sessionservice.removeSessionValue("wSUId");
        that.sessionservice.setSessionStorageItem("userType", "1");
        that.userType = 1; //hardcoding as of now for standalone flow
        this.E2EUId = this.sessionservice.getE2EUId();
        this.CMSUId = this.sessionservice.getCMSUId();
        this.WSUId = this.sessionservice.getWSUId();
        this.DeepDiveDetails.UserType = this.userType;
        this.DeepDiveDetails.E2EUID = this.E2EUId;
        this.DeepDiveDetails.CMSUID = this.CMSUId;
        this.DeepDiveDetails.WSUID = this.WSUId;
        this.DeepDiveDetails.DeliveryConstructUId = this.sessionservice.getDeliveryConstructUId();
        that.DeepDiveDetails.FdsLevel = 0;
        //this.messageService.loadHeader(parseInt(this.proposalId.toFixed()));
        // that.spinner.show();
        // that.GetDeepDiveDetails(that.DeepDiveDetails);
      }
      else {
        // code as per fds
      }
    });
    if ((this.userType == 3 && this.envData.Env == "FDS_ManualUpload") || (this.userType == 1 && this.envData.Env == "SAAS_ManualUpload")) {
      this.E2EUId = this.sessionservice.getE2EUId();
      this.CMSUId = this.sessionservice.getCMSUId();
      this.WSUId = this.sessionservice.getWSUId();
      this.DeepDiveDetails.E2EUID = this.E2EUId;
      this.DeepDiveDetails.CMSUID = this.CMSUId;
      this.DeepDiveDetails.WSUID = this.WSUId;
      this.DeepDiveDetails.DeliveryConstructUId = this.sessionservice.getDeliveryConstructUId();
      this.DeepDiveDetails.UserType = this.userType;
      this.DeepDiveDetails.FdsLevel = this.GetFDSLevel(this.E2EUId, this.CMSUId, this.WSUId);
      this.proposalId = 0;
      this.sessionservice.removeSessionValue('selectedProposalId');
    }
    else if (this.userType == 4) {
      if (sessionStorage.getItem("Instance") != "PAM") 
      {
        that.sessionservice.removeSessionValue("e2EUId");
      }
      this.sessionservice.removeSessionValue("cMSUID");
      this.sessionservice.removeSessionValue("wSUId");
      this.sessionservice.setSessionStorageItem("userType", "4");
      this.solutionId = parseInt(this.sessionservice.getSessionStorageItem('solutionId'));
      this.userType = 4; //MySp Flow
      this.E2EUId = null;
      this.CMSUId = null;
      this.WSUId = null;
      this.DeepDiveDetails.UserType = this.userType;
      this.DeepDiveDetails.E2EUID = null;
      this.DeepDiveDetails.CMSUID = null;
      this.DeepDiveDetails.WSUID = null;
      this.DeepDiveDetails.DeliveryConstructUId = null;

      this.DeepDiveDetails.FdsLevel = 0;
      this.proposalId = this.solutionId;
      this.sessionservice.setSessionStorageItem('selectedProposalId', this.proposalId.toString());
    }
    else {
      if(this.userType == 3 && this.envData.Env == "SAAS_ManualUpload"){
        that.sessionservice.setSessionStorageItem("userType", "3");
        that.userType = 3; //hardcoding as of now for standalone flow
        this.E2EUId = this.sessionservice.getE2EUId();
        this.CMSUId = this.sessionservice.getCMSUId();
        this.WSUId = this.sessionservice.getWSUId();
        this.DeepDiveDetails.UserType = this.userType;
        this.DeepDiveDetails.E2EUID = this.E2EUId;
        this.DeepDiveDetails.CMSUID = this.CMSUId;
        this.DeepDiveDetails.WSUID = this.WSUId;
        this.DeepDiveDetails.DeliveryConstructUId = this.sessionservice.getDeliveryConstructUId();
        that.DeepDiveDetails.FdsLevel = 0;
      }
      else{
        if (sessionStorage.getItem("Instance") != "PAM") 
        {
          that.sessionservice.removeSessionValue("e2EUId");
        }
      this.sessionservice.removeSessionValue("cMSUID");
      this.sessionservice.removeSessionValue("wSUId");
      if (this.envData.Env == "FDS_ManualUpload") {
        this.sessionservice.setSessionStorageItem("userType", "1");
        this.userType = 1; //hardcoding as of now for standalone flow
      }
      else{
        this.sessionservice.setSessionStorageItem("userType", "3");
        this.userType = 3; //hardcoding as of now for standalone flow
      }
      this.proposalId = parseInt(this.sessionservice.getSessionStorageItem('selectedProposalId'));      
      this.E2EUId = null;
      this.CMSUId = null;
      this.WSUId = null;
      this.DeepDiveDetails.UserType = this.userType;
      this.DeepDiveDetails.E2EUID = null;
      this.DeepDiveDetails.CMSUID = null;
      this.DeepDiveDetails.WSUID = null;
      this.DeepDiveDetails.DeliveryConstructUId = null;
      this.DeepDiveDetails.FdsLevel = 0;
      }      
    }
    // this.messageService.currentVersionId.subscribe(msg => this.VersionId = msg);
    // this.messageService.currentDDName.subscribe(msg => this.DDName = msg);
    if ((this.userType == 1) && this.proposalId == 0 && sessionStorage.getItem("Instance") != "PAM") {
      this.navigateToProposalSummary();
    }
    this.spinner.show();
    this.DeepDiveDetails.DomainType = "All";
    if (this.envData.instanceType == "FDS") {
      this.DeepDiveDetails.DeliveryConstructUId = this.sessionservice.getDeliveryConstructUId();
    }
    else {
      this.DeepDiveDetails.ProposalId = this.proposalId;
    }

    this.isDisabled = false;
    this.DeepDiveDetails.UserId = this.sessionservice.getUserName();
    this.GetDeepDiveDetails(this.DeepDiveDetails);
    this.setDropdown();
    this.setIntrvl();
    this.messageService.currentDDredirection.subscribe(msg => {
      if (msg == 'reclassified' || msg == 'reupload') {
        that.isProceed = false;
        that.isLoadDQT = false;
        that.isLoadText = false;
        that.isLoadReview = false;
        that.isLoadTrend = false;
        that.isLoadDeepdive = true;
        that.qpversionId = '';
        this.ddFilter = true;
        //this.filterEnabler = false;
        that.spinner.show();
        that.GetDeepDiveDetails(that.DeepDiveDetails)
      }
      else if(msg == "dqt"){        
        that.isProceed = false;
        that.isLoadDQT = true;
        that.isLoadText = false;
        that.isLoadReview = false;
        that.isLoadTrend = false;
        that.isLoadDeepdive = false;
        that.qpversionId = '';
        that.spinner.show();
        that.GetDeepDiveDetails(that.DeepDiveDetails)
      }
    });
    this.messageService.subjViewDetails.subscribe(msg => {
      if (msg == true) {
        that.spinner.show();
        that.VersionIdMongo = localStorage.getItem('VersionIdMongo');
        that.userType = +this.sessionservice.getSessionStorageItem('userType');
        that.GetOpportunities(false, true);
        this.GetDeepDiveDetails(this.DeepDiveDetails, false); // Refresh the ddtiles
      }
    });
  }
  ngAfterViewInit(): void { this.spinner.show(); }
  ngOnDestroy() {
    clearInterval(this.autoRefresh);
  }
  setDropdown() {
    if (this.otherSearch == true && this.otherSearch1 == true) { this.selectedStatus == 'Select' }
    else if (this.otherSearch == true && this.otherSearch1 == false) { this.selectedStatus == 'Select' }
    else if (this.otherSearch == false && this.otherSearch1 == true) { this.selectedStatus == 'Select' }
    else (this.otherSearch == false && this.otherSearch1 == false)
    { this.selectedStatus == 'All' }
  }

  setIntrvl() {
    var VersionIdMongo = this.sessionservice.getSessionStorageItem('VersionIdMongo');    
    if(VersionIdMongo != null || VersionIdMongo != undefined || VersionIdMongo != ""){    
      this.autoRefresh = setInterval(() =>    
      this.GetDeepDiveStatus(this.DeepDiveDetails, false), this.timeInterval          
    );
    }
    this.autoRefresh = setInterval(() =>
      this.scrollToVersionID(), this.scrolltimeInterval
    );
  }

  //On click of Eye Icon - make it unactive
  hideDeepDive(child) {
    let that = this;
    this.spinner.show();
    this.iomservice.archiveDeepDive(child.VersionIdMongo, false).subscribe(data => {
      this.spinner.hide();
      if (data["Response"] == "Success") {
        this.ddlabel = '';
        bootbox.confirm({
          message: 'Deepdive inactivated successfully',
          buttons: {
            confirm: {
              label: 'Ok',
              className: 'btn-primary'
            },
            cancel: {
              label: '',
              className: 'd-none'
            }
          },
          callback: function (result) {
            if (result) //'Yes' selection
            {
              // window.location.reload();
              that.qpversionId = '';
              that.GetDeepDiveDetails(that.DeepDiveDetails);
            }
          }
        });
      }
    }
      ,
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log("Error Occured !");
      });
    this.GetDeepDiveDetails(this.DeepDiveDetails);
  }

  RefreshFDSDeepdive(child) {
    let that = this;
    this.spinner.show();
    this.iomservice.RefreshFDSDeepdive(child.VersionIdMongo).subscribe(data => {
      this.spinner.hide();
      if (data["Result"] != null && data["Result"] != "Refresh Deepdive failed") {
        this.ddlabel = '';
        bootbox.confirm({
          message: data["Result"],
          buttons: {
            confirm: {
              label: 'Proceed',
              className: 'btn-primary'
            },
            cancel: {
              label: 'Cancel',
              className: 'btn-secondary'
            }
          },
          callback: function (result) {
            if (result) //'Yes' selection
            {
              // window.location.reload();
              that.spinner.show();
              let fd = new FormData()
              fd.append('userId',that.sessionservice.getUserName());
              that.iomservice.LiveCategorization(child.VersionIdMongo,fd).subscribe(data => {
                if (data["Result"] != null && data["Result"] !='Live ticket categorization failed') {
                  that.spinner.hide();
                  bootbox.confirm({
                    message: data["Result"],
                    buttons: {
                      confirm: {
                        label: 'Ok',
                        className: 'btn-primary'
                      },
                      cancel: {
                        label: 'Cancel',
                        className: 'd-none'
                      }
                    },
                    callback: function (result) {
                      if (result) //'Yes' selection
                      {                       
                      }
                    }
                  });
                  that.isProceed = false;
                  that.isLoadDQT = false;
                  that.isLoadText = false;
                  that.isLoadReview = false;
                  that.isLoadTrend = false;
                  that.isLoadDeepdive = true;
                  that.qpversionId = '';
                  this.ddFilter = true;                        
                  that.spinner.show();
                  that.GetDeepDiveDetails(that.DeepDiveDetails)
                  that.router.navigate(['deepdive']);
                }
                else{
                  that.spinner.hide();
                  bootbox.alert(data["Result"]);
                }
              }
                ,
                (err: HttpErrorResponse) => {
                  that.spinner.hide();
                  console.log("Error Occured !");
                });
            }
          }
        });
      }
      else{
        bootbox.alert(data["Result"]);
      }
    }
      ,
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log("Error Occured !");
      });
  }


  //On click of Eye Icon - make it active
  UnhideDeepDive(child) {
    let that = this;
    this.spinner.show();
    this.iomservice.archiveDeepDive(child.VersionIdMongo, true).subscribe(data => {
      this.spinner.hide();
      if (data["Response"] == "Success") {
        this.ddlabel = '';
        bootbox.confirm({
          message: 'Deepdive activated successfully',
          buttons: {
            confirm: {
              label: 'Ok',
              className: 'btn-primary'
            },
            cancel: {
              label: '',
              className: 'd-none'
            }
          },
          callback: function (result) {
            if (result) //'Yes' selection
            {
              that.qpversionId = '';
              that.GetDeepDiveDetails(that.DeepDiveDetails);
            }
          }
        });
      }
    }
      ,
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log("Error Occured !");
      });
    this.GetDeepDiveDetails(this.DeepDiveDetails);
  }

  //Show Active DeepDive
  isActiveDD() {
    // this.sessionservice.setSessionStorageItem("isactive","true");
    // window.location.reload();
    this.spinner.show();
    this.InactiveDD = false;
    // this.qpversionId = '';
    // this.qpddname = null;
    // this.ddlabel = '';
    this.isLoadDeepdive = true;
    this.isLoadReview = false;
    this.isLoadText = false;
    this.isLoadTrend = false;
    this.isLoadDQT = false;
    this.ddFilter = true;
    this.DeepDiveDetails.ShowHide = true;
    this.newstatus1 = false;
    this.filterEnabler = true;
    this.exportEnabler = true;    
    document.getElementById('activedd').classList.add('active');
    document.getElementById('inactivedd').classList.remove('active');
    this.GetDeepDiveDetails(this.DeepDiveDetails);
    if (this.searchText != "") {
      this.getDeepDive(null, false);
    }
    else if (this.startdate != null && this.enddate != null && this.startdate != '' && this.enddate != '' && this.startdate != undefined && this.enddate != undefined) {
      this.DeepDiveDataFiltered = this.DeepDiveData.filter(x => (this.getDate(x.ModifiedOn) <= this.getDate(this.enddate) && this.getDate(x.ModifiedOn) >= this.getDate(this.startdate)));

    }
    else if (this.Isselected1 || this.Isselected2 || this.Isselected3 || this.Isselected4 || this.Isselected5 || this.Isselected6 || this.Isselected7 || this.Isselected8 || this.Isselected9) {
      if (this.Isselected1) {
        this.getDeepDivebyStatus1(null, false);
      }
      else if (this.Isselected2) {
        this.getDeepDivebyStatus2(null, false);
      }
      else if (this.Isselected3) {
        this.getDeepDivebyStatus3(null, false);
      }
      else if (this.Isselected4) {
        this.getDeepDivebyStatus4(null, false);
      }
      else if (this.Isselected5) {
        this.getDeepDivebyStatus5(null, false);
      }
      else if (this.Isselected6) {
        this.getDeepDivebyStatus6(null, false);
      }
      else if (this.Isselected7) {
        this.getDeepDivebyStatus7(null, false);
      }
      else if (this.Isselected8) {
        this.getDeepDivebyStatus8(null, false);
      }
      else if (this.Isselected9) {
        this.getDeepDivebyStatus9(null, false);
      }
    }
    else {
      this.GetDeepDiveDetails(this.DeepDiveDetails);
    }
  }

  //Show In Active DD
  isInActiveDD() {
    this.spinshow = true;
    this.InactiveDD = true;
    this.qpversionId = '';
    this.qpddname = null;
    this.ddlabel = '';
    this.spinner.show();
    this.isLoadDeepdive = true;
    this.isLoadReview = false;
    this.isLoadText = false;
    this.isLoadTrend = false;
    this.isLoadDQT = false;
    this.ddFilter = true;
    this.ddExport = true;
    this.dqtAutomate = true;
    this.filterEnabler = false;
    this.exportEnabler = false;
    this.DeepDiveDetails.ShowHide = false;
    this.sessionservice.setSessionStorageItem("SelectedLanguage", '');
    this.sessionservice.setSessionStorageItem("SelectedDDLanguage", '');
    this.setDDLanguage() 
    document.getElementById('activedd').classList.remove('active');
    document.getElementById('inactivedd').classList.add('active');
    this.GetDeepDiveDetails(this.DeepDiveDetails);
    if (this.searchText != "") {
      this.getDeepDive(null, false);
    }
    else if (this.startdate != null && this.enddate != null && this.startdate != '' && this.enddate != '' && this.startdate != undefined && this.enddate != undefined) {
      this.DeepDiveDataFiltered = this.DeepDiveData.filter(x => (this.getDate(x.ModifiedOn) <= this.getDate(this.enddate) && this.getDate(x.ModifiedOn) >= this.getDate(this.startdate)));

    }
    else if (this.Isselected1 || this.Isselected2 || this.Isselected3 || this.Isselected4 || this.Isselected5 || this.Isselected6 || this.Isselected7 || this.Isselected8 || this.Isselected9) {
      if (this.Isselected1) {
        this.getDeepDivebyStatus1(null, false);
      }
      else if (this.Isselected2) {
        this.getDeepDivebyStatus2(null, false);
      }
      else if (this.Isselected3) {
        this.getDeepDivebyStatus3(null, false);
      }
      else if (this.Isselected4) {
        this.getDeepDivebyStatus4(null, false);
      }
      else if (this.Isselected5) {
        this.getDeepDivebyStatus5(null, false);
      }
      else if (this.Isselected6) {
        this.getDeepDivebyStatus6(null, false);
      }
      else if (this.Isselected7) {
        this.getDeepDivebyStatus7(null, false);
      }
      else if (this.Isselected8) {
        this.getDeepDivebyStatus8(null, false);
      }
      else if (this.Isselected9) {
        this.getDeepDivebyStatus9(null, false);
      }
    }
    else {
      this.GetDeepDiveDetails(this.DeepDiveDetails);
    }
    this.spinner.hide();
  }
  getUrlDetails() {
    if (this.sessionservice.getDeliveryConstructUId() == null || this.sessionservice.getDeliveryConstructUId() == "00000000-0000-0000-0000-000000000000") {
      return
    }
    else {
      if (sessionStorage.getItem('redirectURL') != '' && sessionStorage.getItem('redirectURL') != undefined && sessionStorage.getItem('redirectURL').toLowerCase().includes('versionid')) {
        let that = this;
        this.proposalId = parseInt(this.sessionservice.getSessionStorageItem('selectedProposalId'));
        this.userType = parseInt(this.sessionservice.getSessionStorageItem('userType'));
        this.messageService.subj.subscribe(msg => {
          if ((this.userType == 1 && this.envData.Env == "FDS_ManualUpload")) {
            that.proposalId = msg;
            if (sessionStorage.getItem("Instance") != "PAM") {
              that.sessionservice.removeSessionValue("e2EUId");
            }
            that.sessionservice.removeSessionValue("cMSUID");
            that.sessionservice.removeSessionValue("wSUId");
            that.sessionservice.setSessionStorageItem("userType", this.userType.toString());
            //that.userType = 1; //hardcoding as of now for standalone flow
            that.E2EUId = null;
            that.CMSUId = null;
            that.WSUId = null;
            that.DeepDiveDetails.UserType = this.userType;
            that.DeepDiveDetails.E2EUID = null;
            that.DeepDiveDetails.CMSUID = null;
            that.DeepDiveDetails.WSUID = null;
            that.DeepDiveDetails.DeliveryConstructUId = null;
            that.DeepDiveDetails.FdsLevel = 0;
            //this.messageService.loadHeader(parseInt(this.proposalId.toFixed()));
            // that.spinner.show();
            // that.GetDeepDiveDetails(that.DeepDiveDetails);
          }
          else {
            // code as per fds
          }
        });
        if ((this.userType == 3 && this.envData.Env == "FDS_ManualUpload") || (this.userType == 1 && this.envData.Env == "SAAS_ManualUpload")) {
          this.E2EUId = this.sessionservice.getE2EUId();
          this.CMSUId = this.sessionservice.getCMSUId();
          this.WSUId = this.sessionservice.getWSUId();
          this.DeepDiveDetails.E2EUID = this.E2EUId;
          this.DeepDiveDetails.CMSUID = this.CMSUId;
          this.DeepDiveDetails.WSUID = this.WSUId;
          this.DeepDiveDetails.DeliveryConstructUId = this.sessionservice.getDeliveryConstructUId();
          this.DeepDiveDetails.UserType = this.userType;
          this.DeepDiveDetails.FdsLevel = this.GetFDSLevel(this.E2EUId, this.CMSUId, this.WSUId);
          this.proposalId = 0;
          this.sessionservice.removeSessionValue('selectedProposalId');
        }
        else if (this.userType == 3 && this.envData.Env == "SAAS_ManualUpload") {
          this.E2EUId = this.sessionservice.getE2EUId();
          this.CMSUId = this.sessionservice.getCMSUId();
          this.WSUId = this.sessionservice.getWSUId();                    
          this.E2EUId = this.sessionservice.getE2EUId();
          this.CMSUId = this.sessionservice.getCMSUId();
          this.WSUId = this.sessionservice.getWSUId();
          this.DeepDiveDetails.UserType = this.userType;
          this.DeepDiveDetails.E2EUID = this.E2EUId;
          this.DeepDiveDetails.CMSUID = this.CMSUId;
          this.DeepDiveDetails.WSUID = this.WSUId;
          this.DeepDiveDetails.DeliveryConstructUId = this.sessionservice.getDeliveryConstructUId();
          that.DeepDiveDetails.FdsLevel = 0;
        }
        else if (this.userType == 4) {
          if (sessionStorage.getItem("Instance") != "PAM") 
        {
          that.sessionservice.removeSessionValue("e2EUId");
        }
          this.sessionservice.removeSessionValue("cMSUID");
          this.sessionservice.removeSessionValue("wSUId");
          this.sessionservice.setSessionStorageItem("userType", "4");
          this.solutionId = parseInt(this.sessionservice.getSessionStorageItem('solutionId'));
          this.userType = 4; //MySp Flow
          this.E2EUId = null;
          this.CMSUId = null;
          this.WSUId = null;
          this.DeepDiveDetails.UserType = this.userType;
          this.DeepDiveDetails.E2EUID = null;
          this.DeepDiveDetails.CMSUID = null;
          this.DeepDiveDetails.WSUID = null;
          this.DeepDiveDetails.DeliveryConstructUId = null;

          this.DeepDiveDetails.FdsLevel = 0;
          this.proposalId = this.solutionId;
          this.sessionservice.setSessionStorageItem('selectedProposalId', this.proposalId.toString());
        }
        else {
          if (sessionStorage.getItem("Instance") != "PAM") 
        {
          that.sessionservice.removeSessionValue("e2EUId");
        }
          this.sessionservice.removeSessionValue("cMSUID");
          this.sessionservice.removeSessionValue("wSUId");
          if (this.envData.Env == "FDS_ManualUpload") {
            this.sessionservice.setSessionStorageItem("userType", "1");
            this.userType = 1; //hardcoding as of now for standalone flow
          }
          else{
            this.sessionservice.setSessionStorageItem("userType", "3");
            this.userType = 3; //hardcoding as of now for standalone flow
          }          
          this.proposalId = parseInt(this.sessionservice.getSessionStorageItem('selectedProposalId'));          
          this.E2EUId = null;
          this.CMSUId = null;
          this.WSUId = null;
          this.DeepDiveDetails.UserType = this.userType;
          this.DeepDiveDetails.E2EUID = null;
          this.DeepDiveDetails.CMSUID = null;
          this.DeepDiveDetails.WSUID = null;
          this.DeepDiveDetails.DeliveryConstructUId = null;
          this.DeepDiveDetails.FdsLevel = 0;
        }
      }
    }
  }

  GetDeepDiveDetails(ddDetails: DeepDiveDetails, loadDefaultDD = true) {
    //setTimeout(() => {
    // this.spinner.hide();
    this.getUrlDetails();
    let isSingleDD;
    this.completedDeepDive = "";
    let url = "deepdive";
    let isFilterApplied = false;
    let inactiveDDstatus = false;
    //this.VersionId = 0;
    //this.showcharts = false;
    if (ddDetails.DeliveryConstructUId == null || ddDetails.DeliveryConstructUId == "00000000-0000-0000-0000-000000000000") {
      ddDetails.DeliveryConstructUId = this.sessionservice.getDeliveryConstructUId();
      if (ddDetails.DeliveryConstructUId == null || ddDetails.DeliveryConstructUId == undefined || ddDetails.DeliveryConstructUId == "00000000-0000-0000-0000-000000000000") {
        ddDetails.DeliveryConstructUId = ddDetails.E2EUID;
      }
    }
    if (ddDetails.WSUID == null || ddDetails.WSUID == "00000000-0000-0000-0000-000000000000") {
      ddDetails.WSUID = ddDetails.DeliveryConstructUId;
    }
    // if (sessionStorage.getItem("Instance") == "PAM") {
    //   ddDetails.UserType = 1;
    //   if(this.envData.Env == "SAAS_ManualUpload"){
    //     this.sessionservice.setSessionStorageItem("userType", "1");
    //   }
    // }
    ddDetails.UserType = parseInt(this.sessionservice.getSessionStorageItem('userType'));
    this.iomservice.getDeepDiveSummary(ddDetails).subscribe((data: any) => {
      this.DeepDiveData = data.FileVersions;
      this.DeepDiveDataFiltered = data.FileVersions;
      for (let i = 0; i < this.DeepDiveDataFiltered.length; i++) {
        if (this.DeepDiveDataFiltered[i].EnableDQT == 1) {
          if (this.DeepDiveDataFiltered[i].Status.split(' ')[0].trim() != '3%') {
            this.DeepDiveDataFiltered[i].DDProgressStatus = this.DeepDiveDataFiltered[i].Status.split(' ')[0].trim();
          }
          this.DeepDiveDataFiltered[i].DQTProgressStatus = this.DeepDiveDataFiltered[i].DQTStatus.split(' ')[0].trim();
        }
        else {
          this.DeepDiveDataFiltered[i].DDProgressStatus = this.DeepDiveDataFiltered[i].Status.split(' ')[0].trim();
          this.DeepDiveDataFiltered[i].DQTProgressStatus = this.DeepDiveDataFiltered[i].DQTStatus.split(' ')[0].trim();
        }
      }
      //this.DistinctStatusList = [...new Set(this.DeepDiveDataFiltered.map(x => x.Status))];
      if (this.DeepDiveDataFiltered && this.DeepDiveDataFiltered.length > 0) {
        this.ddDataLength = this.DeepDiveDataFiltered.length;
        if (this.searchText != "") {
          this.getDeepDive(null, false);
          isFilterApplied = true;
        }
        else if (this.startdate != null && this.enddate != null && this.startdate != '' && this.enddate != '' && this.startdate != undefined && this.enddate != undefined) {
          this.DeepDiveDataFiltered = this.DeepDiveData.filter(x => (this.getDate(x.ModifiedOn) <= this.getDate(this.enddate) && this.getDate(x.ModifiedOn) >= this.getDate(this.startdate)));
          isFilterApplied = true;
        }
        else if (this.Isselected1 || this.Isselected2 || this.Isselected3 || this.Isselected4 || this.Isselected5 || this.Isselected6 || this.Isselected7 || this.Isselected8 || this.Isselected9) {
          if (this.Isselected1) {
            this.getDeepDivebyStatus1(null, false);
          }
          else if (this.Isselected2) {
            this.getDeepDivebyStatus2(null, false);
          }
          else if (this.Isselected3) {
            this.getDeepDivebyStatus3(null, false);
          }
          else if (this.Isselected4) {
            this.getDeepDivebyStatus4(null, false);
          }
          else if (this.Isselected5) {
            this.getDeepDivebyStatus5(null, false);
          }
          else if (this.Isselected6) {
            this.getDeepDivebyStatus6(null, false);
          }
          else if (this.Isselected7) {
            this.getDeepDivebyStatus7(null, false);
          }
          else if (this.Isselected8) {
            this.getDeepDivebyStatus8(null, false);
          }
          else if (this.Isselected9) {
            this.getDeepDivebyStatus9(null, false);
          }
        }
        if (this.qpversionId == '' || this.qpddname == null || this.qpddname == undefined) {
          let completedDD = [];
          this.spinner.hide();
          // if (this.envData.instanceType == 'FDS') {
          //   completedDD = this.DeepDiveDataFiltered.filter(x => (x.Status == "Completed" || x.Status == "Reclassification Failed"));
          // }
          // else {
          completedDD = this.DeepDiveDataFiltered.filter(x => (x.Status == "Completed" || x.DQTStatus == "Completed" && x.Status != "Reclassification Failed" && x.Status != "Failed" && x.Status != "No Tickets" && x.Status != "Reupload" && x.Status != "Insufficient tickets" && x.Status != "No Opportunities Found" && x.DQTStatus != "DQT Failed" && x.DQTStatus != 'No Tickets'  && x.Status.split(' ')[2] != 'Inprogress' && x.Status.split(' ')[3] != 'Inprogress'));
          //}
          if(this.DeepDiveDataFiltered.length ==1)
          {
            this.sessionservice.setSessionStorageItem("VersionIdMongo", this.DeepDiveDataFiltered[0].VersionIdMongo);
          }
          let completedDDProgress;
          if(parseInt(this.sessionservice.getSessionStorageItem('userType'))==1){
          completedDDProgress = this.DeepDiveDataFiltered.filter(x => ((x.Status != "Completed" && x.Status != "Reclassification Failed" && x.Status != "Failed" && x.Status != "No Tickets" && x.Status != "Reupload" && x.Status != "Insufficient tickets" && x.Status != "No Opportunities Found") && (x.DQTStatus != "Completed" && x.DQTStatus != "DQT Failed" && x.DQTStatus != 'No Tickets')));
           }
          else{
          completedDDProgress = this.DeepDiveDataFiltered.filter(x => ((x.Status != "Completed" && x.Status != "Reclassification Failed" && x.Status != "Failed" && x.Status != "No Tickets" && x.Status != "Reupload" && x.Status != "Insufficient tickets" && x.Status != "No Opportunities Found") && (x.DQTStatus != "DQT Failed" && x.DQTStatus != 'No Tickets')));
           }
          if(completedDDProgress.length > 0){
            inactiveDDstatus = true;
          }
          if (this.InactiveDD != true) {
            if (completedDDProgress.length > 0 && completedDD.length <= 0) {
              if (completedDDProgress.length > 0) {
                loadDefaultDD = false;
                this.spinner.hide();
                this.deepDivestatus = completedDDProgress[0].Status.split(' ')[0].trim();
                if (completedDDProgress[0].EnableDQT == 1 && completedDDProgress[0].DQTStatus != "Completed" && completedDDProgress[0].DQTStatus != "0% - Inprogress") {
                  this.deepDivestatus = completedDDProgress[0].DQTStatus.split(' ')[0].trim();
                }
              }
              else {
                this.deepDivestatus = completedDDProgress[0].Status.split(' ')[0].trim();
                if (completedDDProgress[0].EnableDQT == 1 && completedDDProgress[0].DQTStatus.split(' ')[0].trim() != "Completed" && completedDDProgress[0].DQTStatus != "0% - Inprogress") {
                  this.deepDivestatus = completedDDProgress[0].DQTStatus.split(' ')[0].trim();
                }
              }
            }

          }
          else {
            if (completedDDProgress.length > 0 && completedDD.length <= 0) {
              if (completedDDProgress.length > 0) {
                this.spinner.hide();
                this.deepDivestatus = completedDDProgress[0].Status.split(' ')[0].trim();
                if (this.completedDeepDive.EnableDQT == 1 && completedDDProgress[0].DQTStatus != "Completed" && completedDDProgress[0].Status != "Completed" && completedDDProgress[0].DQTStatus != "0% - Inprogress") {
                  this.deepDivestatus = completedDDProgress[0].DQTStatus.split(' ')[0].trim();
                }
              }
              else {
                this.deepDivestatus = completedDDProgress[0].Status.split(' ')[0].trim();
                if (this.completedDeepDive.EnableDQT == 1 && completedDDProgress[0].DQTStatus != "Completed" && completedDDProgress[0].Status != "Completed"&& completedDDProgress[0].DQTStatus != "0% - Inprogress") {
                  this.deepDivestatus = completedDDProgress[0].DQTStatus.split(' ')[0].trim();
                }
              }
            }
          }
          this.completedDeepDive = completedDD[0];
          if (this.completedDeepDive != undefined) {
            this.sessionservice.setSessionStorageItem("VersionIdMongo", this.completedDeepDive.VersionIdMongo);
            this.sessionservice.setSessionStorageItem("SelectedLanguage", this.completedDeepDive.Language);
            this.setDDLanguage();
          }
        }
        else {
          let dd = this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId && x.Status !='No Tickets');
            if (dd && dd.length > 0) {
              this.completedDeepDive = this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId)[0];
              this.VersionIdMongo = this.qpversionId;
              if ($('#iomTile_' + this.qpversionId)[0]) {
                if (this.dqtStatus == true){this.expandDD = '';}
                else{
                  if($('#iomTile_' + this.qpversionId).find('.view-header')[0] != undefined){
                    let isCollapsed = $('#iomTile_' + this.qpversionId).find('.view-header')[0].classList.contains('collapsed');
                    if (!isCollapsed && this.completedDeepDive != null && this.completedDeepDive.Status == "Completed") {
                      this.expandDD = this.qpversionId;
                    }
                    else {
                      this.expandDD = '';
                    }
                  }                            
              }             
              }
            }
            else {
              if (!isFilterApplied) {
                let completedDD = [];
                // if (this.envData.instanceType == 'FDS') {
                //   completedDD = this.DeepDiveDataFiltered.filter(x => (x.Status == "Completed" || x.Status == "Reclassification Failed"));
                // }
                // else {
                completedDD = this.DeepDiveDataFiltered.filter(x => (x.Status == "Completed" || x.DQTStatus == "Completed" && (x.Status != "Reclassification Failed" && x.Status != "Failed" && x.Status != "No Tickets" && x.Status != "Reupload" && x.Status != "Insufficient tickets" && x.Status != "No Opportunities Found" && x.Status.split(' ')[2] != "Inprogress") && x.DQTStatus != "DQT Failed" && x.DQTStatus != 'No Tickets'));                
                //}
                if (completedDD.length > 0) {
                  this.completedDeepDive = completedDD[0];
                  this.qpversionId = '';
                  this.qpddname = '';
                  this.ddlabel = '';
                  this.VersionIdMongo = '';
                }
                else {
                  this.spinner.hide();
                }
              }
            }      
        }
        if (this.completedDeepDive != undefined && this.completedDeepDive != "") {
          if (this.completedDeepDive.DQTStatus == "Completed" && this.completedDeepDive.Status != "Completed" && this.completedDeepDive.Status != "Reclassification Failed" && this.completedDeepDive.Status != "Failed" && this.completedDeepDive.Status != "No Tickets" && this.completedDeepDive.Status != "Reupload" && this.completedDeepDive.Status != "Insufficient tickets" && this.completedDeepDive.Status != "No Opportunities Found" && (this.completedDeepDive.Status.split(' ')[2] != "Inprogress" || this.completedDeepDive.Status.split(' ')[0] == "3%")) {
            this.dqtStatus = true;
            this.isLoadDQT = true;
            this.isProceed = true;
          }
          else if (this.completedDeepDive.Status == 'Insufficient tickets' || this.completedDeepDive.Status == 'Reupload' || this.completedDeepDive.Status.split(' ')[2] == "Inprogress"  && this.completedDeepDive.Status.split(' ')[0] != "3%" && this.completedDeepDive.DQTStatus == 'Completed'){
            this.dqtStatus = true;
            this.isLoadDQT = true;
            this.isProceed = false;
          }
          else if (this.completedDeepDive.DQTStatus == "Completed" && this.completedDeepDive.Status == "Failed"){
            this.dqtStatus = true;
            this.isLoadDQT = true;
            this.isProceed = false;
          }
          else if(this.completedDeepDive.DQTStatus == 'DQT Failed' && this.completedDeepDive.Status == 'No Opportunities Found'){
            this.dqtStatus = false;
            this.isLoadDQT = false;            
          }
          else {
            this.dqtStatus = false;
            //this.isLoadDQT = false;
            this.isProceed = false;
          }
          this.enableDQT = true;
          this.IsLemmaEnabled = true;
          this.sessionservice.setSessionStorageItem("IsLemmaEnabled", "true");
          if (this.completedDeepDive.EnableDQT == 0 || this.completedDeepDive.DQTStatus == 'DQT Failed' || this.completedDeepDive.DQTStatus == 'No Tickets' || this.completedDeepDive.DQTStatus.split(' ')[0].trim() == "0%") {
            this.enableDQT = false;
          }
          if (this.completedDeepDive.IsLemmaEnabled == 0) {
            this.sessionservice.setSessionStorageItem("IsLemmaEnabled", "false");
            this.IsLemmaEnabled = false;
          }
          this.sessionservice.setSessionStorageItem("IsACUser", this.completedDeepDive.IsACUser);
          let nooppDQT = this.sessionservice.getSessionStorageItem("nooppDQT")
          if(nooppDQT != "true"){
            this.showcharts = true;
          }        
          this.isDisabled = false;
          this.VersionIdMongo = this.completedDeepDive.VersionIdMongo;
          if (this.newflag == true && sessionStorage.getItem('redirectURL') != '' && sessionStorage.getItem('redirectURL') != undefined && sessionStorage.getItem('redirectURL').toLowerCase().includes('versionid')) {
            loadDefaultDD = true;
            this.newflag = false;
          }
          if (loadDefaultDD || (this.qpversionId == '' || this.qpddname == null || this.qpddname == undefined)) {
            // this.spinner.show();
            setTimeout(() => {
              this.isLoadTrend = false;
              this.isLoadText = false;
              this.isLoadReview = false;
              this.isLoadDQT = false;
              this.isLoadDeepdive = true;
              
            if (this.completedDeepDive.DQTStatus == "Completed" && this.completedDeepDive.Status.split(' ')[0] == "3%")
            {
              this.ddFilter = false;
            }
            else
            {
              this.ddFilter = true;
            }
            if(this.completedDeepDive != "" && this.completedDeepDive != undefined){
              this.ddTileDefaultSelected(this.completedDeepDive);
            }               
              //this.spinner.hide();
            }, 1000);
          }
          else {
            // setTimeout(() => {
            //   if ($("#iomTile_" + this.VersionIdMongo)[0]) {
            //     this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo));
            //   }
            // }, 1000);
          }
        }
        else {
          if (loadDefaultDD || (this.qpversionId == '' || this.qpddname == null || this.qpddname == undefined)) {
            // this.spinner.show();
            if(this.completedDeepDive != undefined && this.completedDeepDive !=""){
            if (this.completedDeepDive.Status != "Completed" && this.completedDeepDive.DQTStatus == "Completed" && this.completedDeepDive.Status != "Reclassification Failed" && this.completedDeepDive.Status != "Failed" && this.completedDeepDive.Status != "No Tickets" && this.completedDeepDive.Status != "Reupload" && this.completedDeepDive.Status != "Insufficient tickets" && this.completedDeepDive.Status != "No Opportunities Found" && this.completedDeepDive.Status.split(' ')[2] != "Inprogress" || this.completedDeepDive.Status.split(' ')[0] == "3%") {
              this.dqtStatus = true;
              this.isLoadDQT = true;
              this.isProceed = true;
            }
            else if (this.completedDeepDive.Status == 'Insufficient tickets' || this.completedDeepDive.Status == 'Reupload' || this.completedDeepDive.Status.split(' ')[2] == "Inprogress" && this.completedDeepDive.Status.split(' ')[0] != "3%" && this.completedDeepDive.DQTStatus == 'Completed'){
              this.dqtStatus = true;
              this.isLoadDQT = true;
              this.isProceed = false;
            }
            else if(this.completedDeepDive.DQTStatus == 'DQT Failed' && this.completedDeepDive.Status == 'No Opportunities Found'){
              this.dqtStatus = false;
              this.isLoadDQT = false;            
            }
            else {
              this.dqtStatus = false;
              //this.isLoadDQT = false;
              this.isProceed = false;
            }
          }
            setTimeout(() => {
              this.isLoadTrend = false;
              this.isLoadText = false;
              this.isLoadReview = false;
              this.isLoadDQT = false;
              this.isLoadDeepdive = true;
              this.ddFilter = true;
              if(this.completedDeepDive != "" && this.completedDeepDive != undefined){
                this.ddTileDefaultSelected(this.completedDeepDive);
              }              
              //this.spinner.hide();
            }, 1000);
          }
          if (!isFilterApplied) {
            this.ddlabel = '';
            this.VersionId = 0;
            this.VersionIdMongo = '';
            this.qpversionId = '';
            this.qpddname = '';
            if (this.userType == 1) // Standalone
            {
              this.location.replaceState(
                this.router.createUrlTree([url]).toString());
            }
            else if (this.userType == 3) // FDS
            {
              if (this.envData.instanceType == 'FDS') {
                this.location.replaceState(
                  this.router.createUrlTree([url], { queryParams: { E2EUId: this.sessionservice.getE2EUId(), CMSUId: this.sessionservice.getCMSUId(), WSUId: this.sessionservice.getWSUId() } }).toString());
              }
              else {
                this.location.replaceState(
                  this.router.createUrlTree([url], { queryParams: { ClientUId: this.sessionservice.getE2EUId(), AssociatedDeliveryConstructUId: this.sessionservice.getCMSUId(), DeliveryConstructUId: this.sessionservice.getWSUId() } }).toString());
              }
            }
            else if (this.userType == 4) // MySolutionPlanner
            {
              this.location.replaceState(
                this.router.createUrlTree([url], { queryParams: { SolutionId: this.sessionservice.getSolutionId() } }).toString());
            }
          }
          this.showcharts = false;
          this.isDisabled = true;
          if (!inactiveDDstatus) {
            this.deepDivestatus = undefined;     
          }
          // this.spinner.hide();
          //document.getElementById('showCategoryDetails').style.visibility = "hidden";
        }
      }
      else {
        if (sessionStorage.getItem('redirectURL') != '' && sessionStorage.getItem('redirectURL') != undefined && sessionStorage.getItem('redirectURL').toLowerCase().includes('versionid') && this.InactiveDD != true) {
          //   if(this.sessionservice.getDeliveryConstructUId() == null || this.sessionservice.getDeliveryConstructUId() == "00000000-0000-0000-0000-000000000000")
          // {
          //   return
          // }
          // else{
          this.GetDeepDiveDetails(this.DeepDiveDetails);
          // }
        }
        else {
          this.ddDataLength = this.DeepDiveDataFiltered.length;
          this.VersionIdMongo = '';
          this.ddlabel = '';
          this.qpversionId = '';
          this.qpddname = '';
          this.showcharts = false;
          if(this,this.ddDataLength == 0){
            this.sessionservice.setSessionStorageItem("VersionIdMongo", "");
            this.sessionservice.setSessionStorageItem("VersionId", "");
          }
          if (this.userType == 1) // Standalone
          {
            this.location.replaceState(
              this.router.createUrlTree([url]).toString());
          }
          else if (this.userType == 3) // FDS
          {
            if (this.envData.instanceType == 'FDS') {
              this.location.replaceState(
                this.router.createUrlTree([url], { queryParams: { E2EUId: this.sessionservice.getE2EUId(), CMSUId: this.sessionservice.getCMSUId(), WSUId: this.sessionservice.getWSUId() } }).toString());
            }
            else {
              this.location.replaceState(
                this.router.createUrlTree([url], { queryParams: { ClientUId: this.sessionservice.getE2EUId(), AssociatedDeliveryConstructUId: this.sessionservice.getCMSUId(), DeliveryConstructUId: this.sessionservice.getWSUId() } }).toString());
            }
          }
          else if (this.userType == 4) // MySolutionPlanner
          {
            this.location.replaceState(
              this.router.createUrlTree([url], { queryParams: { SolutionId: this.sessionservice.getSolutionId() } }).toString());
          }
          if (this.InactiveDD) {
            this.sessionservice.setSessionStorageItem("SelectedLanguage", '');
            this.sessionservice.setSessionStorageItem("SelectedDDLanguage", '');
            this.setDDLanguage() 
            this.activeinactiveddtext = "No In-Active Deepdives Available";
            this.disfilter = true;
          }
          else {
            this.activeinactiveddtext = "No Active Deepdives Available";
            this.disfilter = true;
          }
          this.isDisabled = true;
          this.spinner.hide();
        }
      }
      // var isScroll = this.sessionservice.getSessionStorageItem('Scroll');
      //     if(isScroll == "1")
      //     {
      //       if(this.qpversionId !="undefined")
      //       {
      //         this.scrollToElement(document.querySelector("#iomTile_" + this.qpversionId), false);
      //       }
      //     }
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log("Error Occured !");
      });
    // }, 1000);
  }

  GetDeepDiveStatus(ddDetails: DeepDiveDetails, loadDefaultDD = true) {
    //setTimeout(() => {
    // this.spinner.hide();
    this.getUrlDetails();
    let isSingleDD;
    //this.completedDeepDive = "";
    let url = "deepdive";
    let isFilterApplied = false;
    let inactiveDDstatus = false;
    
    if (ddDetails.DeliveryConstructUId == null || ddDetails.DeliveryConstructUId == "00000000-0000-0000-0000-000000000000") {
      ddDetails.DeliveryConstructUId = this.sessionservice.getDeliveryConstructUId();
      if (ddDetails.DeliveryConstructUId == null || ddDetails.DeliveryConstructUId == undefined || ddDetails.DeliveryConstructUId == "00000000-0000-0000-0000-000000000000") {
        ddDetails.DeliveryConstructUId = ddDetails.E2EUID;
      }
    }
    if (ddDetails.WSUID == null || ddDetails.WSUID == "00000000-0000-0000-0000-000000000000") {
      ddDetails.WSUID = ddDetails.DeliveryConstructUId;
    }
    // if (sessionStorage.getItem("Instance") == "PAM") {
    //   ddDetails.UserType = 1;
    //   if(this.envData.Env == "SAAS_ManualUpload"){
    //     this.sessionservice.setSessionStorageItem("userType", "1");
    //   }
    // }
    ddDetails.UserType = parseInt(this.sessionservice.getSessionStorageItem('userType'));
    this.iomservice.getDeepDiveStatus(ddDetails).subscribe((data: any) => {
      // this.DeepDiveData = data.FileVersions;
      // this.DeepDiveDataFiltered = data.FileVersions;
      if(data.FileVersionsStatus.length>0)
      {
      for (let i = 0; i < data.FileVersionsStatus.length; i++) {
        var CurrStatusData = this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == data.FileVersionsStatus[i].VersionIdMongo);
       if(CurrStatusData.length>0)
       {
        var CurrStatusDataIndex = this.DeepDiveDataFiltered.findIndex(x => x.VersionIdMongo == data.FileVersionsStatus[i].VersionIdMongo);
        CurrStatusData[0].Status = data.FileVersionsStatus[i].Status;
        CurrStatusData[0].DQTStatus = data.FileVersionsStatus[i].DQTStatus;
        CurrStatusData[0].TotalCategory = data.FileVersionsStatus[i].TotalCategory;
        CurrStatusData[0].CategorisedTicketcount = data.FileVersionsStatus[i].CategorisedTicketcount;
        CurrStatusData[0].TotalTicketCount = data.FileVersionsStatus[i].TotalTicketCount;
        CurrStatusData[0].IsDisableEditCatgoryandSubcategory = data.FileVersionsStatus[i].IsDisableEditCatgoryandSubcategory;
        if (CurrStatusData[0].EnableDQT == 1) {
          if (CurrStatusData[0].Status.split(' ')[0].trim() != '3%') {
            CurrStatusData[0].DDProgressStatus = data.FileVersionsStatus[i].Status.split(' ')[0].trim();
          }
          CurrStatusData[0].DQTProgressStatus = data.FileVersionsStatus[i].DQTStatus.split(' ')[0].trim();
        }
        else {
          CurrStatusData[0].DDProgressStatus = data.FileVersionsStatus[i].Status.split(' ')[0].trim();
          CurrStatusData[0].DQTProgressStatus = data.FileVersionsStatus[i].DQTStatus.split(' ')[0].trim();
        }
        this.DeepDiveDataFiltered[CurrStatusDataIndex] = CurrStatusData[0];
      }
      else if (!this.Isselected3 && !this.Isselected4 && !this.Isselected5 && !this.Isselected6 && !this.Isselected7 && !this.Isselected8 && !this.Isselected9)
      {
        if(this.searchText != ""){
          this.getDeepDive(null, false);
          isFilterApplied = true;
        }
        else{
          this.iomservice.getDeepDiveSummary(ddDetails).subscribe((data: any) => {
            this.DeepDiveData = data.FileVersions;
            this.DeepDiveDataFiltered = data.FileVersions;
            // for (let i = 0; i < this.DeepDiveDataFiltered.length; i++) {
            //   if (this.DeepDiveDataFiltered[i].EnableDQT == 1) {
            //     if (this.DeepDiveDataFiltered[i].Status.split(' ')[0].trim() != '3%') {
            //       this.DeepDiveDataFiltered[i].DDProgressStatus = this.DeepDiveDataFiltered[i].Status.split(' ')[0].trim();
            //     }
            //     this.DeepDiveDataFiltered[i].DQTProgressStatus = this.DeepDiveDataFiltered[i].DQTStatus.split(' ')[0].trim();
            //   }
            //   else {
            //     this.DeepDiveDataFiltered[i].DDProgressStatus = this.DeepDiveDataFiltered[i].Status.split(' ')[0].trim();
            //     this.DeepDiveDataFiltered[i].DQTProgressStatus = this.DeepDiveDataFiltered[i].DQTStatus.split(' ')[0].trim();
            //   }
            // }
          },
            (err: HttpErrorResponse) => {
              this.spinner.hide();
              console.log("Error Occured !");
            });
        }
      }    
      }  
      if (this.DeepDiveDataFiltered && this.DeepDiveDataFiltered.length > 0) {
        this.ddDataLength = this.DeepDiveDataFiltered.length;
        if (this.searchText != "") {
          this.getDeepDive(null, false);
          isFilterApplied = true;
        }
        else if (this.startdate != null && this.enddate != null && this.startdate != '' && this.enddate != '' && this.startdate != undefined && this.enddate != undefined) {
          this.DeepDiveDataFiltered = this.DeepDiveData.filter(x => (this.getDate(x.ModifiedOn) <= this.getDate(this.enddate) && this.getDate(x.ModifiedOn) >= this.getDate(this.startdate)));
          isFilterApplied = true;
        }
        else if (this.Isselected1 || this.Isselected2 || this.Isselected3 || this.Isselected4 || this.Isselected5 || this.Isselected6 || this.Isselected7 || this.Isselected8 || this.Isselected9) {
          if (this.Isselected1) {
            this.getDeepDivebyStatus1(null, false);
          }
          else if (this.Isselected2) {
            this.getDeepDivebyStatus2(null, false);
          }
          else if (this.Isselected3) {
            this.getDeepDivebyStatus3(null, false);
          }
          else if (this.Isselected4) {
            this.getDeepDivebyStatus4(null, false);
          }
          else if (this.Isselected5) {
            this.getDeepDivebyStatus5(null, false);
          }
          else if (this.Isselected6) {
            this.getDeepDivebyStatus6(null, false);
          }
          else if (this.Isselected7) {
            this.getDeepDivebyStatus7(null, false);
          }
          else if (this.Isselected8) {
            this.getDeepDivebyStatus8(null, false);
          }
          else if (this.Isselected9) {
            this.getDeepDivebyStatus9(null, false);
          }
        }
        if (this.qpversionId == '' || this.qpddname == null || this.qpddname == undefined) {
          let completedDD = [];
          this.spinner.hide();
          // if (this.envData.instanceType == 'FDS') {
          //   completedDD = this.DeepDiveDataFiltered.filter(x => (x.Status == "Completed" || x.Status == "Reclassification Failed"));
          // }
          // else {
          completedDD = this.DeepDiveDataFiltered.filter(x => (x.Status == "Completed" || x.DQTStatus == "Completed" && x.Status != "Reclassification Failed" && x.Status != "Failed" && x.Status != "No Tickets" && x.Status != "Reupload" && x.Status != "Insufficient tickets" && x.Status != "No Opportunities Found" && x.DQTStatus != "DQT Failed" && x.DQTStatus != 'No Tickets'  && x.Status.split(' ')[2] != 'Inprogress' && x.Status.split(' ')[3] != 'Inprogress'));
          //}
          let completedDDProgress = this.DeepDiveDataFiltered.filter(x => ((x.Status != "Completed" && x.Status != "Reclassification Failed" && x.Status != "Failed" && x.Status != "No Tickets" && x.Status != "Reupload" && x.Status != "Insufficient tickets" && x.Status != "No Opportunities Found") && (x.DQTStatus != "Completed" && x.DQTStatus != "DQT Failed" && x.DQTStatus != 'No Tickets')));

          if(completedDDProgress.length > 0){
            inactiveDDstatus = true;
          }
          if (this.InactiveDD != true) {
            if (completedDDProgress.length > 0 && completedDD.length <= 0) {
              if (completedDDProgress.length > 0) {
                loadDefaultDD = false;
                this.spinner.hide();
                this.deepDivestatus = completedDDProgress[0].Status.split(' ')[0].trim();
                if (completedDDProgress[0].EnableDQT == 1 && completedDDProgress[0].DQTStatus != "Completed") {
                  this.deepDivestatus = completedDDProgress[0].DQTStatus.split(' ')[0].trim();
                }
              }
              else {
                this.deepDivestatus = completedDDProgress[0].Status.split(' ')[0].trim();
                if (completedDDProgress[0].EnableDQT == 1 && completedDDProgress[0].DQTStatus.split(' ')[0].trim() != "Completed") {
                  this.deepDivestatus = completedDDProgress[0].DQTStatus.split(' ')[0].trim();
                }
              }
            }

          }
          else {
            if (completedDDProgress.length > 0 && completedDD.length <= 0) {
              if (completedDDProgress.length > 0) {
                this.spinner.hide();
                this.deepDivestatus = completedDDProgress[0].Status.split(' ')[0].trim();
                if (this.completedDeepDive.EnableDQT == 1 && completedDDProgress[0].DQTStatus != "Completed" && completedDDProgress[0].Status != "Completed") {
                  this.deepDivestatus = completedDDProgress[0].DQTStatus.split(' ')[0].trim();
                }
              }
              else {
                this.deepDivestatus = completedDDProgress[0].Status.split(' ')[0].trim();
                if (this.completedDeepDive.EnableDQT == 1 && completedDDProgress[0].DQTStatus != "Completed" && completedDDProgress[0].Status != "Completed") {
                  this.deepDivestatus = completedDDProgress[0].DQTStatus.split(' ')[0].trim();
                }
              }
            }
          }
          this.completedDeepDive = completedDD[0];
          if (this.completedDeepDive != undefined) {
            this.sessionservice.setSessionStorageItem("VersionIdMongo", this.completedDeepDive.VersionIdMongo);
          }
        }
        else {
          let dd = this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId);
            if (dd && dd.length > 0) {
              this.completedDeepDive = this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId)[0];
              this.VersionIdMongo = this.qpversionId;
              if ($('#iomTile_' + this.qpversionId)[0]) {
                if (this.dqtStatus == true){this.expandDD = '';}
                else{
                  if($('#iomTile_' + this.qpversionId).find('.view-header')[0] != undefined){
                    let isCollapsed = $('#iomTile_' + this.qpversionId).find('.view-header')[0].classList.contains('collapsed');
                    if (!isCollapsed && this.completedDeepDive != null && this.completedDeepDive.Status == "Completed") {
                      this.expandDD = this.qpversionId;
                    }
                    else {
                      this.expandDD = '';
                    }
                  }                            
              }             
              }
            }
            else {
              if (!isFilterApplied) {
                let completedDD = [];
                // if (this.envData.instanceType == 'FDS') {
                //   completedDD = this.DeepDiveDataFiltered.filter(x => (x.Status == "Completed" || x.Status == "Reclassification Failed"));
                // }
                // else {
                completedDD = this.DeepDiveDataFiltered.filter(x => (x.Status == "Completed" || x.DQTStatus == "Completed" && (x.Status != "Reclassification Failed" && x.Status != "Failed" && x.Status != "No Tickets" && x.Status != "Reupload" && x.Status != "Insufficient tickets" && x.Status != "No Opportunities Found" && x.Status.split(' ')[2] != "Inprogress") && x.DQTStatus != "DQT Failed" && x.DQTStatus != 'No Tickets'));                
                //}
                if (completedDD.length > 0) {
                  this.completedDeepDive = completedDD[0];
                  this.qpversionId = '';
                  this.qpddname = '';
                  this.ddlabel = '';
                  this.VersionIdMongo = '';
                }
                else {
                  this.spinner.hide();
                }
              }
            }      
        }
        if (this.completedDeepDive != undefined && this.completedDeepDive != "") {
          if (this.completedDeepDive.DQTStatus == "Completed" && this.completedDeepDive.Status != "Completed" && this.completedDeepDive.Status != "Reclassification Failed" && this.completedDeepDive.Status != "Failed" && this.completedDeepDive.Status != "No Tickets" && this.completedDeepDive.Status != "Reupload" && this.completedDeepDive.Status != "Insufficient tickets" && this.completedDeepDive.Status != "No Opportunities Found" && (this.completedDeepDive.Status.split(' ')[2] != "Inprogress" || this.completedDeepDive.Status.split(' ')[0] == "3%")) {
            this.dqtStatus = true;
            this.isLoadDQT = true;
            this.isProceed = true;
          }
          else if (this.completedDeepDive.Status == 'Insufficient tickets' || this.completedDeepDive.Status == 'Reupload' || this.completedDeepDive.Status.split(' ')[2] == "Inprogress"  && this.completedDeepDive.Status.split(' ')[0] != "3%" && this.completedDeepDive.DQTStatus == 'Completed'){
            this.dqtStatus = true;
            this.isLoadDQT = true;
            this.isProceed = false;
          }
          else if (this.completedDeepDive.DQTStatus == "Completed" && this.completedDeepDive.Status == "Failed"){
            this.dqtStatus = true;
            this.isLoadDQT = true;
            this.isProceed = false;
          }
          else if(this.completedDeepDive.DQTStatus == 'DQT Failed' && this.completedDeepDive.Status == 'No Opportunities Found'){
            this.dqtStatus = false;
            this.isLoadDQT = false;            
          }
          else {
            this.dqtStatus = false;
            //this.isLoadDQT = false;
            this.isProceed = false;
          }
          this.enableDQT = true;
          if (this.completedDeepDive.EnableDQT == 0 || this.completedDeepDive.DQTStatus == 'DQT Failed' || this.completedDeepDive.DQTStatus == 'No Tickets' || this.completedDeepDive.DQTStatus.split(' ')[0].trim() == "0%") {
            this.enableDQT = false;
          }
          let nooppDQT = this.sessionservice.getSessionStorageItem("nooppDQT")
          if(nooppDQT != "true"){
            this.showcharts = true;
          }          
          this.isDisabled = false;
          this.VersionIdMongo = this.completedDeepDive.VersionIdMongo;
          if (this.newflag == true && sessionStorage.getItem('redirectURL') != '' && sessionStorage.getItem('redirectURL') != undefined && sessionStorage.getItem('redirectURL').toLowerCase().includes('versionid')) {
            loadDefaultDD = true;
            this.newflag = false;
          }
          if (loadDefaultDD || (this.qpversionId == '' || this.qpddname == null || this.qpddname == undefined)) {
            // this.spinner.show();
            setTimeout(() => {
              this.isLoadTrend = false;
              this.isLoadText = false;
              this.isLoadReview = false;
              this.isLoadDQT = false;
              this.isLoadDeepdive = true;
              
            if (this.completedDeepDive.DQTStatus == "Completed" && this.completedDeepDive.Status.split(' ')[0] == "3%")
            {
              this.ddFilter = false;
            }
            else
            {
              this.ddFilter = true;
            }
            if(this.completedDeepDive != "" && this.completedDeepDive != undefined){
              this.ddTileDefaultSelected(this.completedDeepDive);
            }               
              //this.spinner.hide();
            }, 1000);
          }
          else {
            // setTimeout(() => {
            //   if ($("#iomTile_" + this.VersionIdMongo)[0]) {
            //     this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo));
            //   }
            // }, 1000);
          }
        }
        else {
          if (loadDefaultDD || (this.qpversionId == '' || this.qpddname == null || this.qpddname == undefined)) {
            // this.spinner.show();
            if(this.completedDeepDive != undefined){
            if (this.completedDeepDive.Status != "Completed" && this.completedDeepDive.DQTStatus == "Completed" && this.completedDeepDive.Status != "Reclassification Failed" && this.completedDeepDive.Status != "Failed" && this.completedDeepDive.Status != "No Tickets" && this.completedDeepDive.Status != "Reupload" && this.completedDeepDive.Status != "Insufficient tickets" && this.completedDeepDive.Status != "No Opportunities Found" && this.completedDeepDive.Status.split(' ')[2] != "Inprogress" || this.completedDeepDive.Status.split(' ')[0] == "3%") {
              this.dqtStatus = true;
              this.isLoadDQT = true;
              this.isProceed = true;
            }
            else if (this.completedDeepDive.Status == 'Insufficient tickets' || this.completedDeepDive.Status == 'Reupload' || this.completedDeepDive.Status.split(' ')[2] == "Inprogress" && this.completedDeepDive.Status.split(' ')[0] != "3%" && this.completedDeepDive.DQTStatus == 'Completed'){
              this.dqtStatus = true;
              this.isLoadDQT = true;
              this.isProceed = false;
            }
            else if(this.completedDeepDive.DQTStatus == 'DQT Failed' && this.completedDeepDive.Status == 'No Opportunities Found'){
              this.dqtStatus = false;
              this.isLoadDQT = false;            
            }
            else {
              this.dqtStatus = false;
              //this.isLoadDQT = false;
              this.isProceed = false;
            }
          }
            setTimeout(() => {
              this.isLoadTrend = false;
              this.isLoadText = false;
              this.isLoadReview = false;
              this.isLoadDQT = false;
              this.isLoadDeepdive = true;
              this.ddFilter = true;
              if(this.completedDeepDive != "" && this.completedDeepDive != undefined){
                this.ddTileDefaultSelected(this.completedDeepDive);
              }              
              //this.spinner.hide();
            }, 1000);
          }
          if (!isFilterApplied) {
            this.ddlabel = '';
            this.VersionId = 0;
            this.VersionIdMongo = '';
            this.qpversionId = '';
            this.qpddname = '';
            if (this.userType == 1) // Standalone
            {
              this.location.replaceState(
                this.router.createUrlTree([url]).toString());
            }
            else if (this.userType == 3) // FDS
            {
              if (this.envData.instanceType == 'FDS') {
                this.location.replaceState(
                  this.router.createUrlTree([url], { queryParams: { E2EUId: this.sessionservice.getE2EUId(), CMSUId: this.sessionservice.getCMSUId(), WSUId: this.sessionservice.getWSUId() } }).toString());
              }
              else {
                this.location.replaceState(
                  this.router.createUrlTree([url], { queryParams: { ClientUId: this.sessionservice.getE2EUId(), AssociatedDeliveryConstructUId: this.sessionservice.getCMSUId(), DeliveryConstructUId: this.sessionservice.getWSUId() } }).toString());
              }
            }
            else if (this.userType == 4) // MySolutionPlanner
            {
              this.location.replaceState(
                this.router.createUrlTree([url], { queryParams: { SolutionId: this.sessionservice.getSolutionId() } }).toString());
            }
          }
          this.showcharts = false;
          this.isDisabled = true;
          // if (!inactiveDDstatus) {
          //   this.deepDivestatus = undefined;     
          // }
          // this.spinner.hide();
          //document.getElementById('showCategoryDetails').style.visibility = "hidden";
        }      
      }
    }
    // else 
    // {
    //   var userType = parseInt(this.sessionservice.getSessionStorageItem('userType'));
    //   if(userType == 1)
    //   {
    //   var VersionIdMongoupdated = localStorage.getItem('VersionIdMongo');
    //   if(VersionIdMongoupdated)
    //   {
    //     this.GetDeepDiveDetails(this.DeepDiveDetails);
    //   }
    // }
    // }
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log("Error Occured !");
      });
    // }, 1000);
    
  }

  ddTileDefaultSelected(child) {
    let isValidDD: boolean;    
    // if (this.envData.instanceType == 'FDS') {
    //   isValidDD = child.Status == 'Completed' || child.Status == 'Reclassification Failed'
    // }
    // else {
    if (child.Status != 'Completed' && child.Status != "No Opportunities Found" && child.DQTStatus == 'Completed' && child.Status != "Reclassification Failed" && child.Status != "Failed" && child.Status != "No Tickets" && child.Status != "Reupload" && child.Status != "Insufficient tickets" && child.Status != "No Opportunities Found" && child.Status.split(' ')[2] != "Inprogress" || child.Status.split(' ')[0] == "3%") {
      this.dqtStatus = true;
      this.isLoadDQT = true;
      this.isProceed = true;
    }
    else if (child.Status == 'Insufficient tickets' || child.Status == 'Reupload' || child.Status.split(' ')[2]  == "Inprogress" && child.Status.split(' ')[0] != "3%" && child.DQTStatus == 'Completed') {
      this.dqtStatus = true;
      this.isLoadDQT = true;
      this.isProceed = false;
    }
    else if(this.completedDeepDive.DQTStatus == 'DQT Failed' && this.completedDeepDive.Status == 'No Opportunities Found'){
      this.dqtStatus = false;
      this.isLoadDQT = false;            
    }
    else {
      this.dqtStatus = false;
      //this.isLoadDQT = false;
      this.isProceed = false;
    }
    if (child.TotalTicketCount > 0 && child.Status == 'No Opportunities Found') {
      this.ddExport = true;
      this.dqtAutomate = false;
    }
    else if (child.TotalTicketCount > 0) {
      this.ddExport = true;
      this.dqtAutomate = true;
    }
    else {
      this.ddExport = false;
      this.dqtAutomate = false;
    }
    if (child.Status == 'No Opportunities Found' && (child.DQTStatus == 'Completed' || this.completedDeepDive.DQTStatus == 'DQT Failed' || this.completedDeepDive.DQTStatus == 'No Tickets' || child.DQTStatus.split(' ')[0] == '0%')) {
      this.showcharts = false;
      this.isDisabled = false;
      this.newstatus = false;
      this.newstatus1 = true;
      this.activeinactiveddtext = "No Opportunities Found";
    }
    if (child.Status == 'No Opportunities Found') {          
      this.showcharts = false;
      this.isDisabled = false;
      this.newstatus = false;
      this.newstatus1 = true;
      this.activeinactiveddtext = "No Opportunities Found";
      this.deepDivestatus = "No Opportunities Found";
    }
    if (child.Status == 'Completed') {          
      this.showcharts = true;
      this.isDisabled = false;
      this.newstatus = false;
      this.newstatus1 = false;
      this.deepDivestatus = "Completed";
    }
    if(child.DQTStatus == "Completed" && (child.Status.split(' ')[0] == "3%" || child.Status == 'Insufficient tickets' || child.Status == 'Reupload' || child.Status == 'Failed')){          
      this.showcharts = true;
      this.isDisabled = false;
      this.newstatus = false;
      this.newstatus1 = false;
      this.deepDivestatus = "Completed";
    }
    if (child.Status == 'No Opportunities Found' && child.DQTStatus == "Completed") {          
      this.showcharts = true;
      this.isDisabled = false;
      this.newstatus = false;
      this.newstatus1 = true;
      this.activeinactiveddtext = "No Opportunities Found";
      this.deepDivestatus = "No Opportunities Found";
      if(this.enableDQT){
        this.sessionservice.setSessionStorageItem("nooppDQT", "true");            
        this.deepDivestatus = "Completed";
      }          
    }
    else if (child.Status == 'Completed') {          
      this.showcharts = true;
      this.isDisabled = false;
      this.newstatus = false;
      this.newstatus1 = false;
      this.deepDivestatus = "Completed";
      this.sessionservice.setSessionStorageItem("nooppDQT", "false"); 
    }    
    isValidDD = (child.Status == 'Completed' && child.DQTStatus == 'Completed');
    //}
    localStorage.removeItem('VersionId');
    localStorage.removeItem('VersionIdMongo');
    this.VersionId = child.VersionId;
    this.VersionIdMongo = child.VersionIdMongo;
    this.userType = child.UserType;
    localStorage.setItem('VersionIdMongo', child.VersionIdMongo);
    this.sessionservice.setSessionStorageItem("VersionIdMongo", child.VersionIdMongo);
    this.sessionservice.setSessionStorageItem("SelectedLanguage", child.Language);
    this.setDDLanguage();

    this.selectedTileName = child.DDName;
    this.displayExpandTreeMap = false;
    this.ExpandTreemap = false;
    this.DQTFilterDetails = [];
    this.lstFilterResponse = [];
    this.lstSelectedFilterVals = [];
    this.TotalTicketCountLabel = child.TotalTicketCount;
    this.CategorisedTicketcount = child.CategorisedTicketcount;

    //Converting the percentage to 95 instead of 100 as the max width of the progress bar is 95%
    this.TicketPercentage = Math.floor((child.CategorisedTicketcount / child.TotalTicketCount) * 95);

    const queryParamsObj = { VersionId: child.VersionIdMongo, DDName: child.DDName };
    this.qpversionId = child.VersionIdMongo; this.qpddname = child.DDName;
    if (child.VersionIdMongo != null && child.VersionIdMongo != undefined) {
      this.location.replaceState(
        this.router.createUrlTree(
          ['Ticket/Index'], // Get uri
          { queryParams: queryParamsObj } // Pass all parameters inside queryParamsObj
        ).toString()
      );
    }
    this.messageService.updateVersionId(child.VersionIdMongo);
    this.messageService.updateDDName(child.DDName);
    this.ddlabel = child.DDName;
    if (isValidDD)
      this.GetOpportunities(true, true, true);
    else
      this.GetOpportunities(true, true, false);
    this.Filter();
    // this.GetDonutTicketDetail();
    // load key chart
    this.getKeyChartsDetails(this.VersionIdMongo);
  }

  //On click DD Tiles.
  ddtiles(event: any, child) {
    if ((child.Status == 'Completed' || child.Status == 'No Opportunities Found' || child.DQTStatus == 'Completed')  && child.Status != 'Reclassification Failed' && child.Status != 'No Tickets' && (child.Status.split(' ')[2] != "Inprogress" || child.Status.split(' ')[0] == "3%") && child.Status.split(' ')[2] != "Reclassification") {
      if (child.Status != 'Completed' && child.Status != 'No Opportunities Found' && child.Status != 'Insufficient tickets' && child.Status != 'Reupload' && child.Status != 'Failed' && child.DQTStatus == 'Completed') {
        this.dqtStatus = true;
        this.isLoadDQT = true;
        this.isProceed = true;
      }
      else if (child.Status == 'Insufficient tickets' || child.Status == 'Reupload' || child.Status.split(' ')[2] == "Inprogress" || child.Status == 'Failed' && child.Status.split(' ')[0] != "3%" && child.DQTStatus == 'Completed'){
        this.dqtStatus = true;
        this.isLoadDQT = true;
        this.isProceed = false;
      }
      // else if (child.Status == 'No Opportunities Found'  && child.DQTStatus == 'Completed'){
      //   this.dqtStatus = true;
      //   this.isLoadDQT = true;
      //   this.isProceed = false;
      // }
      else if(child.DQTStatus == 'DQT Failed' && child.Status == 'No Opportunities Found'){
        this.dqtStatus = false;
        this.isLoadDQT = false;        
      }
      else {
       this.dqtStatus = false;
        //this.isLoadDQT = false;
        this.isProceed = false; 
      }
      if (this.nocallddtiles == 'false' || (this.sessionservice.getSessionStorageItem('nocallDDtiles') == 'false')) {
        this.sessionservice.setSessionStorageItem("nooppDQT", "false");  
        this.wordreset = true
        this.displayFilter = false;        
        this.DQTFilterDetails = [];
        this.lstFilterResponse = [];
        this.lstSelectedFilterVals = [];
        let isValidDD: boolean;
        let isSingleDD: boolean;
        // if (this.envData.instanceType == 'FDS') {
        //   isValidDD = child.Status == 'Completed' || child.Status == 'Reclassification Failed'
        //   isSingleDD = this.DeepDiveDataFiltered.filter(x => x.Status == 'Completed' || x.Status == 'Reclassification Failed').length == 1
        // }
        // else {
        if (child.TotalTicketCount > 0) {
          this.ddExport = true;
          this.dqtAutomate = true;
        }
        else {
          this.ddExport = false;
          this.dqtAutomate = false;
        }
        this.enableDQT = true;
        this.IsLemmaEnabled = true;
        this.sessionservice.setSessionStorageItem("IsLemmaEnabled", "true");
        this.sessionservice.setSessionStorageItem("IsLemmaChecked", "0");
        if (child.EnableDQT == 0 || child.DQTStatus == 'DQT Failed' || child.DQTStatus == 'No Tickets' || child.DQTStatus.split(' ')[0].trim() == "0%") {
          this.enableDQT = false;
        }
        if (child.IsLemmaEnabled == 0) {
          this.IsLemmaEnabled = false;
          this.sessionservice.setSessionStorageItem("IsLemmaEnabled", "false");
        }
        this.sessionservice.setSessionStorageItem("IsACUser", child.IsACUser);
        isValidDD = (child.Status == 'Completed' || child.Status == 'No Opportunities Found' || child.DQTStatus == 'Completed');
        isSingleDD = this.DeepDiveDataFiltered.filter(x => (x.Status == 'Completed' || x.Status == 'No Opportunities Found' || x.DQTStatus == 'Completed')).length == 1
        //}
        if (child.Status == 'No Opportunities Found') {          
          this.showcharts = false;
          this.isDisabled = false;
          this.newstatus = false;
          this.newstatus1 = true;
          this.activeinactiveddtext = "No Opportunities Found";
          this.deepDivestatus = "No Opportunities Found";
        }
        if (child.Status == 'Completed') {          
          this.showcharts = true;
          this.isDisabled = false;
          this.newstatus = false;
          this.newstatus1 = false;
          this.deepDivestatus = "Completed";
        }
        if(child.DQTStatus == "Completed" && (child.Status.split(' ')[0] == "3%" || child.Status == 'Insufficient tickets' || child.Status == 'Reupload' || child.Status == 'Failed')){          
          this.showcharts = true;
          this.isDisabled = false;
          this.newstatus = false;
          this.newstatus1 = false;
          this.deepDivestatus = "Completed";
        }
        if (child.Status == 'No Opportunities Found' && child.DQTStatus == "Completed") {          
          this.showcharts = true;
          this.isDisabled = false;
          this.newstatus = false;
          this.newstatus1 = true;
          this.activeinactiveddtext = "No Opportunities Found";
          this.deepDivestatus = "No Opportunities Found";
          if(this.enableDQT){
            this.sessionservice.setSessionStorageItem("nooppDQT", "true");            
            // this.showcharts = true;
            // this.isDisabled = false;
            // this.newstatus = false;
            // this.newstatus1 = false;
            this.deepDivestatus = "Completed";
          }          
        }
        if (isValidDD && (event.target.innerText == 'View Details' || event.target.classList.contains('subCatCls') || event.target.classList.contains('catCls'))) {
          return;
        }
        else if (isValidDD) {
          // if (parseInt(localStorage.getItem('VersionId')) == child.VersionId) {
          //   $('#iomTile_' + child.VersionId).find('.view-header')[0].click();
          //   //this.expandDD = child.VersionId;
          // }
          this.ActiveCat = null;
          this.ActiveSubcat = null;
          localStorage.removeItem('VersionId');
          localStorage.removeItem('VersionIdMongo');
          localStorage.setItem('VersionIdMongo', child.VersionIdMongo);
          this.sessionservice.setSessionStorageItem("VersionIdMongo", child.VersionIdMongo);
          this.sessionservice.setSessionStorageItem("SelectedLanguage", child.Language);
          this.sessionservice.setSessionStorageItem("SelectedDDLanguage", null);
          this.setDDLanguage();
          this.VersionId = child.VersionId;
          this.VersionIdMongo = child.VersionIdMongo;
          this.userType = child.UserType;
          // $('.view-body').removeClass('show');
          // if (event.currentTarget.id == "iomTile_" + child.VersionId) {
          //   this.isView = child.VersionId;
          // }

          if (isValidDD) {
            //this.catValues = [true]; 
            //this.loadDeepdive();
            //this.spinner.show();       
            this.displayExpandTreeMap = false;
            localStorage.removeItem('CategoryId');
            localStorage.removeItem('SubCategoryId');
            this.selectedTileName = child.DDName;
            this.ExpandTreemap = false;
            const queryParamsObj = { VersionId: child.VersionIdMongo, DDName: child.DDName };
            this.qpversionId = child.VersionIdMongo; this.qpddname = child.DDName;
            this.location.replaceState(
              this.router.createUrlTree(
                ['Ticket/Index'], // Get uri
                { queryParams: queryParamsObj } // Pass all parameters inside queryParamsObj
              ).toString()
            );
            this.messageService.updateVersionId(child.VersionIdMongo);
            this.messageService.updateDDName(child.DDName);
            this.ddlabel = child.DDName;
            this.sessionservice.setSessionStorageItem("VersionIdMongo", child.VersionIdMongo);
            this.sessionservice.setSessionStorageItem("SelectedLanguage", child.Language);
            this.setDDLanguage();
            if (this.isLoadTrend && !this.isLoadDQT) {
              this.spinner.show();
              this.magicNumber++;
              this.TextcategoryOrSubcategoryName = null;
              this.TextTicketCount = 0;
              this.CatSubcatData = null;
              this.GetOpportunities(false, false, true);
              this.isLoadTrend = true;
              this.isLoadDeepdive = false;
              this.isLoadReview = false;
              this.isLoadText = false;
              this.ddFilter = false;
              this.isLoadDQT = false;
            }
            else if (this.isLoadText && !this.isLoadDQT) {
              this.spinner.show();
              this.magicNumber++;
              this.TextcategoryOrSubcategoryName = null;
              this.TextTicketCount = 0;
              this.GetOpportunities(false, false, true);
              this.isLoadTrend = false;
              this.isLoadDeepdive = false;
              this.isLoadReview = false;
              this.isLoadText = true;
              this.ddFilter = false;
              this.isLoadDQT = false;
            }
            else if (this.isLoadDQT && this.enableDQT) {
              this.spinner.show();
              this.magicNumber++;
              this.TextcategoryOrSubcategoryName = null;
              this.TextTicketCount = 0;
              //this.GetOpportunities(false, false, true);
              this.isLoadTrend = false;
              this.isLoadDeepdive = false;
              this.isLoadReview = false;
              this.isLoadText = false;
              this.ddFilter = false;
              this.isLoadDQT = true;
            }
            else if (this.isLoadReview && !this.isLoadDQT) {
              this.spinner.show();
              this.TextcategoryOrSubcategoryName = null;
              this.TextTicketCount = 0;
              this.magicNumber++;
              this.Filter();
              if (isSingleDD)
                this.GetOpportunities(false, false, true);
              else
                this.GetOpportunities(false, false, false);
              this.isLoadTrend = false;
              this.isLoadDeepdive = false;
              this.isLoadReview = true;
              this.isLoadText = false;
              this.ddFilter = true;
              this.isLoadDQT = false;
            }
            else {
              this.spinner.show();
              this.Filter();
              this.isLoadDeepdive = true;
              this.isLoadTrend = false;
              this.isLoadReview = false;
              this.isLoadText = false;
              this.ddFilter = true;
              this.isLoadDQT = false;
              this.getKeyChartsDetails(child.VersionIdMongo);
              // this.TotalTicketCountLabel = child.TotalTicketCount;
              // this.CategorisedTicketcount = child.CategorisedTicketcount;
              this.TextcategoryOrSubcategoryName = null;
              this.TextTicketCount = this.CategorisedTicketcount;

              //Converting the percentage to 95 instead of 100 as the max width of the progress bar is 95%
              this.TicketPercentage = Math.floor((child.CategorisedTicketcount / child.TotalTicketCount) * 95);

              if (isSingleDD)
                this.GetOpportunities(false, true, true);
              else
                this.GetOpportunities(false, true, false);
            }
          }
          this.scrollToElement(document.querySelector("#iomTile_" + child.VersionIdMongo), true);
        }
        else {
          // Do Nothing
        }
      }
    }

  }
  GetOpportunities(isLoad = false, loadticketData = false, isExpand = false) {
    this.ClearClassifiedTicket();
    //API to get DD Tile Details
    this.spinner.show();   
    this.GetDonutTicketDetail();
    this.displayExpandTreeMap = false;
    this.loadDoughnut = false;
    this.CatSubcatData = null;
    this.displayExpandTreeMap = false;
    this.isdataAvailable = false;    
    if (sessionStorage.getItem('redirectURL') != null && sessionStorage.getItem('redirectURL') != '' && sessionStorage.getItem('redirectURL') != undefined 
        && sessionStorage.getItem('redirectURL').toLowerCase().includes('e2euid') && sessionStorage.getItem('redirectURL').includes('PAM')){
      this.userType = 1;
    }
    var SelectedLanguage = this.sessionservice.getSessionStorageItem('SelectedDDLanguage');
    var SelectedLanguageEdit = this.sessionservice.getSessionStorageItem('SelectedLanguage');
  
    if(SelectedLanguage==null || SelectedLanguage==undefined || SelectedLanguage=='' || SelectedLanguage=='null')
    {
      SelectedLanguage='All';
    }
    else if(SelectedLanguageEdit!=null && SelectedLanguageEdit!=undefined)
    {
      if(!SelectedLanguageEdit.includes('|'))
      {
        SelectedLanguage='All';
      }
    }
    this.iomservice.getAMOTileProperties<any>(this.VersionIdMongo, SelectedLanguage, this.userType, this.DQTFilterDetails).subscribe(data => {    
      if (isLoad) {
        // if ($("#iomTile_" + this.VersionIdMongo)[0]) {
        //   this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo), true);
        // }
      }
      if (data && data.length > 0) {
        this.showcharts = true;
        this.isDisabled = false;
        this.classifyBy = data[0].InsightBy;
        this.InsightBy = data[0].opportunityby;
        this.DDStartDate = data[0].DDDetails.StartDate;
        this.DDEndDate = data[0].DDDetails.EndDate;
         //set visibility based on TicketType value
         if(data[0].DDDetails.TicketType == '' || data[0].DDDetails.TicketType == null)
         {
           this.showDDTicketType = false;
         }
         else
         {
           this.showDDTicketType = true;
         }
        this.DDTicketType = data[0].DDDetails.TicketType
        this.DDClassificationBasedOn = data[0].DDDetails.ClassificationBasedOn;
        this.DDAlgorithm = data[0].DDDetails.Algorithm
        this.CatSubcatData = data;
        this.NoDataCat = false;
        if (this.CatSubcatData.length > 10) {
          this.displayExpandTreeMap = true;
        }
        if (loadticketData) {
          let child = this.DeepDiveDataFiltered.find(x => x.VersionIdMongo == this.VersionIdMongo);
          // this.GetDonutTicketDetail();
          //this.TotalTicketCountLabel = child.TotalTicketCount;
          //this.CategorisedTicketcount = child.CategorisedTicketcount;
          //this.TicketPercentage = Math.floor((child.CategorisedTicketcount / child.TotalTicketCount) * 95);
        }
        if (isExpand) {
          this.expandDD = this.VersionIdMongo;
        }
        else {
          this.expandDD = '';
        }
         this.spinner.hide();
      }
      else {
        this.NoDataCat = true;
        this.isdataAvailable = true;        
        let nooppDQT = this.sessionservice.getSessionStorageItem("nooppDQT")
        if(nooppDQT == "true"){
          this.showcharts = false;
          this.isDisabled = false;
          this.newstatus = false;
          this.newstatus1 = true;
          this.activeinactiveddtext = "No Opportunities Found";
          this.deepDivestatus = "No Opportunities Found";
        }
        this.spinner.hide();
      }
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log("Error Occured !");
      });
  }
  ClearClassifiedTicket() {
    this.TotalTicketCountLabel = 0;
    this.CategorisedTicketcount = 0;
    this.TicketPercentage = 0;
  }
  scrollToElement($element, scrollWindow = false): void {
    //console.log($element);
    //window.scrollTo(0, 0);
    // let dims = $element.getBoundingClientRect();
    // window.scrollTo({
    //   top: dims.top - 20,
    //   behavior: "smooth"
    // });
    if ($element != null) {
      //this.scrollTo($('.iom-list.ScrollDDY')[0], topPos - 30, 600);
      //$element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      if (scrollWindow) {
        var topPos = $element.offsetTop;
        $('.iom-list.ScrollDDY')[0].scrollTop = topPos - 55;
        setTimeout(function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 700);
      }
      else {
        var topPos = $element.offsetTop;
        $('.iom-list.ScrollDDY')[0].scrollTop = topPos - 55;
        setTimeout(function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 100);
        this.sessionservice.setSessionStorageItem("Scroll", "0");
      }
    }
    else {
      this.sessionservice.setSessionStorageItem("Scroll", "1");
      // setTimeout(function () {this.GetDeepDiveDetails(this.DeepDiveDetails); }, 50);
      // setTimeout(this.GetDeepDiveDetails(this.DeepDiveDetails),50)
      // setTimeout(()=>{this.GetDeepDiveDetails(this.DeepDiveDetails)},50);
    }
  }

  scrollToVersionID() {
    var isScroll = this.sessionservice.getSessionStorageItem('Scroll');
    if (isScroll == "1") {
      if (this.qpversionId != "undefined") {
        this.scrollToElement(document.querySelector("#iomTile_" + this.qpversionId), false);
      }
    }
  }
  navigateToCreatedeepdive() {
    //added for testing purpose since getting usertype value 6 from PAM API
    //this.userType = 3;
    this.iomservice.isManualUpload = false;
    this.sessionservice.setSessionStorageItem("reUpload", "false");
    if (this.userType == null) {
      this.userType = parseInt(this.sessionservice.getSessionStorageItem('userType'));
    }
    switch (this.userType) {
      case 1:
        if (sessionStorage.getItem("Instance") == "PAM") {
          let e2EUID = this.sessionservice.getE2EUId();
          if(e2EUID==null)
          {
            e2EUID = this.sessionservice.getDeliveryConstructUId();
          }
          let cMSUID = this.sessionservice.getCMSUId();
          let wSUID = this.sessionservice.getWSUId();
          if (this.envData.instanceType == 'FDS') {
            this.router.navigate(['createdeepdive'], { queryParams: { E2EUId: e2EUID, CMSUId: cMSUID, WSUId: wSUID } });
          }
        }
        else
          this.router.navigate(["createdeepdive"]);
        break;
      case 3:
        let e2EUID = this.sessionservice.getE2EUId();
        if(e2EUID==null)
        {
           e2EUID = this.sessionservice.getDeliveryConstructUId();
        }
        let cMSUID = this.sessionservice.getCMSUId();
        let wSUID = this.sessionservice.getWSUId();
        if (this.envData.instanceType == 'FDS') {
          if (sessionStorage.getItem('Instance') != 'PAM' && this.envData.Env == "SAAS_ManualUpload")
          {
            this.iomservice.isManualUpload = true;
          }
          this.router.navigate(['createdeepdive'], { queryParams: { E2EUId: e2EUID, CMSUId: cMSUID, WSUId: wSUID } });
        }
        else {
          this.router.navigate(['createdeepdive'], { queryParams: { ClientUId: e2EUID, AssociatedDeliveryConstructUId: cMSUID, DeliveryConstructUId: wSUID } });
        }
        break;
      case 4:
        this.router.navigate(['createdeepdive'], { queryParams: { SolutionId: this.sessionservice.getSolutionId() } });
        break;
      default:
        break;
    }
  }

  navigateToProposalSummary() {
    this.router.navigate(["proposalsummary"]);
  }

  navigateToCreateProposal() {
    this.router.navigate(["createproposal"]);
  }
  navigateToTrendAnalysis() {
    this.router.navigate(['trendanalysis'], { queryParams: { versionId: this.VersionIdMongo } });
  }

  getDeepDive(event: any, handleRightPane) {
    if (this.searchText == '') {
      this.DeepDiveDataFiltered = this.DeepDiveData;
      this.ddDataLength = this.DeepDiveDataFiltered.length;
      this.otherSearch = false;
    } else {
      this.DeepDiveDataFiltered = this.DeepDiveData.filter(x => x.DDName.toLowerCase().indexOf(this.searchText.toLocaleLowerCase()) >= 0);
      this.ddDataLength = this.DeepDiveDataFiltered.length;
      this.otherSearch = true;
      this.selectedStatus = 'Select';
    }
    if (handleRightPane) {
      if(this.activeinactiveddtext!=undefined && this.activeinactiveddtext != "There is no deepdives available for the search text" && this.activeinactiveddtext != "" && this.activeinactiveddtext != null){
        this.prevactiveddtext = this.activeinactiveddtext;
       }
      if (this.DeepDiveDataFiltered != null && this.DeepDiveDataFiltered.length > 0 && this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId).length > 0) {
        this.showcharts = true;
        this.isDisabled = false;
        if(this.prevactiveddtext!=undefined){
          this.activeinactiveddtext = this.prevactiveddtext;
          }
        // setTimeout(() => {
        //   if ($("#iomTile_" + this.VersionIdMongo)[0]) {
        //     this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo));
        //   }
        // }, 1000);
      }
      else {
        this.showcharts = false;
        this.ddDataLength = this.DeepDiveDataFiltered.length;
        this.isDisabled = true;
        if (this.searchText != '') {
          this.activeinactiveddtext = "There is no deepdives available for the search text";
          this.disfilter = true;
        }
        else {
          if (this.InactiveDD) {
            this.activeinactiveddtext = "No In-Active Deepdives Available";
            this.disfilter = true;
          }
          else {
            this.activeinactiveddtext = "No Active Deepdives Available";
            this.disfilter = true;
          }
        }
      }
    }
    this.startdate = null;
    this.enddate = null;
    this.selectedDate1 = null;
    this.selectedDate2 = null;
    this.Isselected1 = false; this.Isselected2 = false; this.Isselected3 = false; this.Isselected4 = false; this.Isselected5 = false; this.Isselected6 = false; this.Isselected7 = false; this.Isselected8 = false;
    this.Isselected9 = false;
  }

  getDeepDivebyStartDate(event: any) {
    var day = event.day;
    if (day.toString().length == 1) {
      var actualDay = "0" + day;
    } else { actualDay = day; }
    var mon = event.month;
    if (mon.toString().length == 1) {
      var actualMon = "0" + mon;
    } else { actualMon = mon; }
    var year = event.year;
    var date1;
    var datechecker;
    if (this.envData.instanceType == 'FDS') {
      date1 = actualMon + "/" + actualDay + "/" + year;
      datechecker = actualMon + "/" + actualDay + "/" + year;

    }
    else {
      date1 = actualMon + "/" + actualDay + "/" + year;
      datechecker = actualMon + "/" + actualDay + "/" + year;
    }


    this.startdate = date1.toString();
    this.startdatechecker = datechecker.toString();
    this.otherSearch1 = true;
    this.selectedStatus = 'Select';
  }

  getDeepDivebyEndDate(event: any) {
    var day = event.day;
    if (day.toString().length == 1) {
      var actualDay = "0" + day;
    } else { actualDay = day; }
    var mon = event.month;
    if (mon.toString().length == 1) {
      var actualMon = "0" + mon;
    } else { actualMon = mon; }
    var year = event.year;
    var date1
    var datechecker;
    if (this.envData.instanceType == 'FDS') {
      date1 = actualMon + "/" + actualDay + "/" + year;
      datechecker = actualMon + "/" + actualDay + "/" + year;
    }
    else {
      date1 = actualMon + "/" + actualDay + "/" + year;
      datechecker = actualMon + "/" + actualDay + "/" + year;
    }

    this.enddate = date1.toString();
    this.enddatechecker = datechecker.toString();
    this.otherSearch1 = true;
    this.selectedStatus = 'Select';
  }
  getDate(dateString: string) {
    var dateParts = dateString.split("/");
    // month is 0-based, that's why we need dataParts[1] - 1
   
    return new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
  }
  getDDbasedonSelectedDates(event: any, handleRightPane) {
    if (this.startdate == '' || this.startdate == null) {
      bootbox.alert("Please Select the Start Date");
      return false;
    }
    else if (this.enddate == '' || this.enddate == null) {
      bootbox.alert("Please Select the End Date");
      return false;
    }
    else if (this.startdatechecker > this.enddatechecker) {
      bootbox.alert("Start date should be less than End date");
      return false;
    } else {
      this.displayCal = false;
      this.DeepDiveDataFiltered = this.DeepDiveData.filter(x => x.ModifiedOn <= this.enddate && x.ModifiedOn >= this.startdate); //modified is changed to uploaded date in api      
      // this.DeepDiveDataFiltered = this.DeepDiveDataFiltered1.filter(x => x.ModifiedOn.substring(3) <= this.enddate1 && x.ModifiedOn.substring(3) >= this.startdate1) //modified is changed to uploaded date in api      
      this.ddDataLength = this.DeepDiveDataFiltered.length;
      if (this.DeepDiveDataFiltered.length > 0) {
        if (this.DeepDiveDataFiltered[0].Status == 'Completed' || this.DeepDiveDataFiltered[0].DQTStatus == 'Completed') {
          if(this.completedDeepDive != "" && this.completedDeepDive != undefined){
            this.ddTileDefaultSelected(this.DeepDiveDataFiltered[0]);
          }           
        }
        else {
          this.DeepDiveDataFiltered1 = this.DeepDiveDataFiltered.filter(x => x.Status == 'Completed' || x.DQTStatus == 'Completed')
          if(this.completedDeepDive != "" && this.completedDeepDive != undefined){
            this.ddTileDefaultSelected(this.DeepDiveDataFiltered1[0]);
          }          
        }
      }
      this.searchText = '';
      this.Isselected1 = false; this.Isselected2 = false; this.Isselected3 = false; this.Isselected4 = false; this.Isselected5 = false; this.Isselected6 = false; this.Isselected7 = false; this.Isselected8 = false;
      this.Isselected9 = false;
      if (handleRightPane) {
        if (this.DeepDiveDataFiltered && this.DeepDiveDataFiltered.length > 0 && this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId).length > 0) {
          this.showcharts = true;
          this.isDisabled = false;
          // setTimeout(() => {
          //   if ($("#iomTile_" + this.VersionIdMongo)[0]) {
          //     this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo));
          //   }
          // }, 1000);
        }
        else {
          this.showcharts = false;
          this.ddDataLength = this.DeepDiveDataFiltered.length;
          this.isDisabled = true;
          this.activeinactiveddtext = "No deepdives available for the selected date range";
          this.disfilter = true;
        }
      }
    }
  }

  clearAllbasedonSelectedDated(event: any) {
    this.displayCal = false;
    this.DeepDiveDataFiltered = this.DeepDiveData;
    this.ddDataLength = this.DeepDiveDataFiltered.length;
    if (this.DeepDiveDataFiltered && this.DeepDiveDataFiltered.length > 0 && this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId).length > 0) {
      this.showcharts = true;
      this.isDisabled = false;
      // setTimeout(() => {
      //   if ($("#iomTile_" + this.VersionIdMongo)[0]) {
      //     this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo));
      //   }
      // }, 1000);
    }
    else {
      this.showcharts = false;
      this.isDisabled = true;
      if (this.InactiveDD) {
        this.activeinactiveddtext = "No In-Active Deepdives Available";
        this.disfilter = true;
      }
      else {
        this.activeinactiveddtext = "No Active Deepdives Available";
        this.disfilter = true;
      }
    }
    this.startdate = null;
    this.enddate = null;
    this.selectedDate1 = null;
    this.selectedDate2 = null;
    this.Isselected5 = false;
    this.Isselected4 = false;
    this.Isselected3 = false;
    this.Isselected2 = false;
    this.Isselected1 = false;
    this.Isselected6 = false;
    this.Isselected7 = false;
    this.Isselected8 = false;
    this.Isselected9 = false;
  }

  getDeepDivebyDate1(event: any) {
    this.DeepDiveDataFiltered = this.DeepDiveData;
    this.otherSearch1 = false;
    if (this.otherSearch1 == false) {
      this.selectedStatus = 'All';
    }
  }

  getDeepDivebyDate2(event: any) {
    this.DeepDiveDataFiltered = this.DeepDiveData;
    this.otherSearch1 = false;
    if (this.otherSearch1 == false) {
      this.selectedStatus = 'All';
    }
  }

  getDeepDivebyStatus1(event: any, handleRightPane) { //All
    this.Isselected5 = false;
    this.Isselected4 = false;
    this.Isselected3 = false;
    this.Isselected2 = false;
    this.Isselected1 = true;    // if (this.selectedStatus == 'All') {}
    this.Isselected6 = false;
    this.Isselected7 = false;
    this.Isselected8 = false;
    this.Isselected9 = false;
    this.startdate = null;
    this.enddate = null;
    this.selectedDate1 = null;
    this.selectedDate2 = null;
    this.searchText = '';
    this.DeepDiveDataFiltered = this.DeepDiveData;
    this.ddDataLength = this.DeepDiveDataFiltered.length;
    if (this.spinshow == true) {
      this.spinner.show();
    }
    if (event != null) {
      this.spinner.show();
    }
    this.spinshow = false;
    if (handleRightPane) {
      if (this.DeepDiveDataFiltered && this.DeepDiveDataFiltered.length > 0 && this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId).length > 0) {
        this.showcharts = true;
        this.isDisabled = false;
        this.newstatus = false;
        this.disfilter = false;
        this.spinner.show();
        // this.newstatus1 = false;
        this.GetDeepDiveDetails(this.DeepDiveDetails);
        this.spinner.hide();
        // setTimeout(() => {
        //   if ($("#iomTile_" + this.VersionIdMongo)[0]) {
        //     this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo));
        //   }
        // }, 1000);
      }
      else {
        this.showcharts = false;
        this.ddDataLength = this.DeepDiveDataFiltered.length;
        this.isDisabled = true;
        this.activeinactiveddtext = "No deepdives available for the selected status";
        this.disfilter = true;
        this.spinner.hide();
      }
    }
  }
  getDeepDivebyStatus2(event: any, handleRightPane) { //Completed
    this.Isselected5 = false;
    this.Isselected4 = false;
    this.Isselected3 = false;
    this.Isselected2 = true;
    this.Isselected1 = false;    // if (this.selectedStatus == 'Completed') {}
    this.Isselected6 = false;
    this.Isselected7 = false;
    this.Isselected8 = false;
    this.Isselected9 = false;
    this.startdate = null;
    this.enddate = null;
    this.selectedDate1 = null;
    this.selectedDate2 = null;
    this.searchText = '';
    this.DeepDiveDataFiltered = this.DeepDiveData.filter(x => x.Status == "Completed" || x.DQTStatus == "Completed" && x.Status != 'No Opportunities Found' && x.Status != 'Failed' && x.Status != 'Reclassification Failed' && x.Status != 'No Tickets' && x.Status != 'Reupload' && x.Status != 'Insufficient tickets' && x.Status.split(' ').length >= 2 ? (x.Status.split(' ')[2] != "Inprogress") : "");
    this.ddDataLength = this.DeepDiveDataFiltered.length;

    if (handleRightPane) {
      if (this.DeepDiveDataFiltered.length > 0) {
        if (this.DeepDiveDataFiltered[0].Status == 'Completed' || this.DeepDiveDataFiltered[0].DQTStatus == 'Completed' && this.DeepDiveDataFiltered[0].Status != 'No Opportunities Found' && this.DeepDiveDataFiltered[0].Status != 'Failed' && this.DeepDiveDataFiltered[0].Status != 'Reclassification Failed' && this.DeepDiveDataFiltered[0].Status != 'No Tickets' && this.DeepDiveDataFiltered[0].Status != 'Reupload' && this.DeepDiveDataFiltered[0].Status != 'Insufficient tickets' && this.DeepDiveDataFiltered[0].Status.split(' ').length >= 2 ? (this.DeepDiveDataFiltered[0].Status.split(' ')[2] != "Inprogress") : "") {
          this.ddTileDefaultSelected(this.DeepDiveDataFiltered[0]);          
        }
      }
      if (this.DeepDiveDataFiltered && this.DeepDiveDataFiltered.length > 0 && this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId).length > 0) {
        this.showcharts = true;
        this.isDisabled = false;
        this.newstatus = false;
        this.newstatus1 = false;
        this.disfilter = false;

        // setTimeout(() => {
        //   if ($("#iomTile_" + this.VersionIdMongo)[0]) {
        //     this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo));
        //   }
        // }, 1000);
      }
      else {
        this.showcharts = false;
        this.ddDataLength = this.DeepDiveDataFiltered.length;
        this.isDisabled = true;
        this.newstatus = false;
        this.newstatus1 = false;
        this.activeinactiveddtext = "No deepdives available for the selected status";
        this.disfilter = true;
      }
    }
  }
  getDeepDivebyStatus3(event: any, handleRightPane) { //Failed
    this.Isselected5 = false;
    this.Isselected4 = false;
    this.Isselected3 = true;
    this.Isselected2 = false;
    this.Isselected1 = false;
    this.Isselected6 = false;
    this.Isselected7 = false;
    this.Isselected8 = false;
    this.Isselected9 = false;
    this.startdate = null;
    this.enddate = null;
    this.selectedDate1 = null;
    this.selectedDate2 = null;
    this.searchText = '';
    this.DeepDiveDataFiltered = this.DeepDiveData.filter(x => (x.Status == "Failed" || x.DQTStatus == "DQT Failed" && x.Status != 'No Opportunities Found' && x.Status != 'Completed' && x.Status != 'Reclassification Failed' && x.Status != 'No Tickets' && x.Status != 'Reupload' && x.Status != 'Insufficient tickets' && x.Status.split(' ').length >= 2 ? (x.Status.split(' ')[2] != "Inprogress") : ""));
    this.ddDataLength = this.DeepDiveDataFiltered.length;
    if(this.ddDataLength>0){
    this.deepDivestatus = this.DeepDiveDataFiltered[0].Status.split(' ')[0].trim();
    }
    if (this.DeepDiveDataFiltered && this.DeepDiveDataFiltered.length > 0 && this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId).length > 0) {
      this.showcharts = true;
      this.isDisabled = false;
      this.newstatus = false;
      this.newstatus1 = false;
      this.disfilter = true;
      // setTimeout(() => {
      //   if ($("#iomTile_" + this.VersionIdMongo)[0]) {
      //     this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo));
      //   }
      // }, 1000);
    }
    else {
      this.showcharts = false;
      this.ddDataLength = this.DeepDiveDataFiltered.length;
      this.isDisabled = true;
      this.newstatus = false;
      this.newstatus1 = false;
      this.activeinactiveddtext = "No deepdives available for the selected status";
      this.disfilter = true;
    }
  }
  getDeepDivebyStatus4(event: any, handleRightPane) {  //Reclassification failed
    this.Isselected5 = false;
    this.Isselected4 = true;
    this.Isselected3 = false;
    this.Isselected2 = false;
    this.Isselected1 = false;
    this.Isselected6 = false;
    this.Isselected7 = false;
    this.Isselected8 = false;
    this.Isselected9 = false;
    this.startdate = null;
    this.enddate = null;
    this.selectedDate1 = null;
    this.selectedDate2 = null;
    this.searchText = '';
    this.DeepDiveDataFiltered = this.DeepDiveData.filter(x => x.Status == "Reclassification Failed");
    this.ddDataLength = this.DeepDiveDataFiltered.length;

    if (handleRightPane) {
      if (this.DeepDiveDataFiltered && this.DeepDiveDataFiltered.length > 0 && this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId).length > 0) {
        this.showcharts = true;
        this.isDisabled = false;
        this.newstatus = false;
        this.newstatus1 = false;
        this.disfilter = false;

        // setTimeout(() => {
        //   if ($("#iomTile_" + this.VersionIdMongo)[0]) {
        //     this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo));
        //   }
        // }, 1000);
      }
      else {
        this.showcharts = false;
        this.ddDataLength = this.DeepDiveDataFiltered.length;
        this.isDisabled = true;
        this.newstatus = false;
        this.newstatus1 = false;
        this.activeinactiveddtext = "No deepdives available for the selected status";
        this.disfilter = true;
      }
    }
  }
  getDeepDivebyStatus5(event: any, handleRightPane) { //InProgress
    this.Isselected5 = true;
    this.Isselected4 = false;
    this.Isselected3 = false;
    this.Isselected2 = false;
    this.Isselected1 = false;
    this.Isselected7 = false;
    this.Isselected6 = false;
    this.Isselected8 = false;
    this.Isselected9 = false;
    this.startdate = null;
    this.enddate = null;
    this.selectedDate1 = null;
    this.selectedDate2 = null;
    this.searchText = '';
    this.DeepDiveDataFiltered = this.DeepDiveData.filter(x => (x.Status != "Completed" && x.Status != "No Opportunities Found" && x.Status != "Failed" && x.Status != "Reclassification Failed" && x.Status != "No Tickets" && x.Status != "Reupload" && x.Status != "Insufficient tickets" && x.Status.split(' ')[0].trim() != "3%"));
    this.ddDataLength = this.DeepDiveDataFiltered.length;
    if (handleRightPane) {
      if (this.ddDataLength > 0) {
        this.deepDivestatus = this.DeepDiveDataFiltered[0].Status.split(' ')[0].trim();
      }
      else {
        //this.deepDivestatus = this.DeepDiveDataFiltered[0].Status.split(' ')[0].trim();
      }

      if (this.DeepDiveDataFiltered && this.DeepDiveDataFiltered.length > 0 && this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId).length > 0) {
        this.showcharts = true;
        this.isDisabled = false;
        this.newstatus = false;
        this.newstatus1 = false;
        this.disfilter = false;
        // setTimeout(() => {
        //   if ($("#iomTile_" + this.VersionIdMongo)[0]) {
        //     this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo));
        //   }
        // }, 1000);
      }
      else {
        this.showcharts = false;
        this.ddDataLength = this.DeepDiveDataFiltered.length;
        this.isDisabled = true;
        this.newstatus = false;
        this.newstatus1 = false;
        this.activeinactiveddtext = "No deepdives available for the selected status";
        this.disfilter = true;
      }
      this.GetDeepDiveDetails(this.DeepDiveDetails);
    }
  }
  getDeepDivebyStatus6(event: any, handleRightPane) { //Insufficient tickets
    this.Isselected5 = false;
    this.Isselected4 = false;
    this.Isselected3 = false;
    this.Isselected2 = false;
    this.Isselected1 = false;
    this.Isselected7 = false;
    this.Isselected8 = false;
    this.Isselected9 = false;
    this.Isselected6 = true;    // if (this.selectedStatus == 'Insufficient tickets') {}
    this.startdate = null;
    this.enddate = null;
    this.selectedDate1 = null;
    this.selectedDate2 = null;
    this.searchText = '';
    this.DeepDiveDataFiltered = this.DeepDiveData.filter(x => x.Status == "Insufficient tickets");
    this.ddDataLength = this.DeepDiveDataFiltered.length;

    if (handleRightPane) {
      if (this.DeepDiveDataFiltered && this.DeepDiveDataFiltered.length > 0) { //&& this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId).length > 0
        this.showcharts = false;
        this.isDisabled = true;
        this.newstatus = true;
        this.newstatus1 = false;
        this.activeinactiveddtext = "No Sufficient categories generated by algorithm";
        this.disfilter = true;
        // setTimeout(() => {
        //   if ($("#iomTile_" + this.VersionIdMongo)[0]) {
        //     this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo));
        //   }
        // }, 1000);
      }
      else {
        this.showcharts = false;
        this.ddDataLength = this.DeepDiveDataFiltered.length;
        this.isDisabled = true;
        this.newstatus = false;
        this.newstatus1 = false;
        this.activeinactiveddtext = "No deepdives available for the selected status";
        this.disfilter = true;
      }
    }
  }
  getDeepDivebyStatus7(event: any, handleRightPane) { //No opportunity
    this.Isselected5 = false;
    this.Isselected4 = false;
    this.Isselected3 = false;
    this.Isselected2 = false;
    this.Isselected1 = false;
    this.Isselected6 = false;
    this.Isselected7 = true;    // if (this.selectedStatus == 'No opportunities Found') {}
    this.Isselected8 = false;
    this.Isselected9 = false;
    this.startdate = null;
    this.enddate = null;
    this.selectedDate1 = null;
    this.selectedDate2 = null;
    this.searchText = '';
    this.DeepDiveDataFiltered = this.DeepDiveData.filter(x => x.Status == "No Opportunities Found");
    this.ddDataLength = this.DeepDiveDataFiltered.length;

    if (handleRightPane) {
      if (this.DeepDiveDataFiltered.length > 0) {
        if (this.DeepDiveDataFiltered[0].Status == 'No Opportunities Found') {
          this.ddTileDefaultSelected(this.DeepDiveDataFiltered[0]);
        }
      }
      if (this.DeepDiveDataFiltered && this.DeepDiveDataFiltered.length > 0) { //&& this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId).length > 0
        this.showcharts = false;
        this.isDisabled = false;
        this.newstatus = false;
        this.newstatus1 = true;
        this.activeinactiveddtext = "No Opportunities Found";
        this.disfilter = true;
        // setTimeout(() => {
        //   if ($("#iomTile_" + this.VersionIdMongo)[0]) {
        //     this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo));
        //   }
        // }, 1000);
      }
      else {
        this.showcharts = false;
        this.ddDataLength = this.DeepDiveDataFiltered.length;
        this.isDisabled = true;
        this.newstatus = false;
        this.newstatus1 = false;
        this.activeinactiveddtext = "No deepdives available for the selected status";
        this.disfilter = true;
      }
    }
  }
  getDeepDivebyStatus8(event: any, handleRightPane) { //No Tickets
    this.Isselected5 = false;
    this.Isselected4 = false;
    this.Isselected3 = false;
    this.Isselected2 = false;
    this.Isselected1 = false;
    this.Isselected6 = false;
    this.Isselected7 = false;
    this.Isselected8 = true;
    this.Isselected9 = false;
    this.startdate = null;
    this.enddate = null;
    this.selectedDate1 = null;
    this.selectedDate2 = null;
    this.searchText = '';
    this.DeepDiveDataFiltered = this.DeepDiveData.filter(x => (x.Status == "No Tickets"));
    this.ddDataLength = this.DeepDiveDataFiltered.length;
    if (this.ddDataLength > 0) {
      this.deepDivestatus = this.DeepDiveDataFiltered[0].Status.split(' ')[0].trim();
    }
    if (this.DeepDiveDataFiltered && this.DeepDiveDataFiltered.length > 0 && this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId).length > 0) {
      this.showcharts = true;
      this.isDisabled = false;
      this.newstatus = false;
      this.newstatus1 = false;
      this.disfilter = true;
      // setTimeout(() => {
      //   if ($("#iomTile_" + this.VersionIdMongo)[0]) {
      //     this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo));
      //   }
      // }, 1000);
    }
    else {
      this.showcharts = false;
      this.ddDataLength = this.DeepDiveDataFiltered.length;
      this.isDisabled = true;
      this.newstatus = false;
      this.newstatus1 = false;
      this.activeinactiveddtext = "No deepdives available for the selected status";
      this.disfilter = true;
    }
  }
  getDeepDivebyStatus9(event: any, handleRightPane) { //ReUpload
    this.Isselected5 = false;
    this.Isselected4 = false;
    this.Isselected3 = false;
    this.Isselected2 = false;
    this.Isselected1 = false;
    this.Isselected6 = false;
    this.Isselected7 = false;
    this.Isselected8 = false;
    this.Isselected9 = true;
    this.startdate = null;
    this.enddate = null;
    this.selectedDate1 = null;
    this.selectedDate2 = null;
    this.searchText = '';
    this.DeepDiveDataFiltered = this.DeepDiveData.filter(x => (x.Status == "Reupload"));
    this.ddDataLength = this.DeepDiveDataFiltered.length;

    if (this.DeepDiveDataFiltered && this.DeepDiveDataFiltered.length > 0 && this.DeepDiveDataFiltered.filter(x => x.VersionIdMongo == this.qpversionId).length > 0) {
      this.showcharts = true;
      this.isDisabled = false;
      this.newstatus = false;
      this.newstatus1 = false;
      this.disfilter = true;
      // setTimeout(() => {
      //   if ($("#iomTile_" + this.VersionIdMongo)[0]) {
      //     this.scrollToElement(document.querySelector("#iomTile_" + this.VersionIdMongo));
      //   }
      // }, 1000);
    }
    else {
      this.showcharts = false;
      this.ddDataLength = this.DeepDiveDataFiltered.length;
      this.isDisabled = true;
      this.newstatus = false;
      this.newstatus1 = false;
      this.activeinactiveddtext = "No deepdives available for the selected status";
      this.disfilter = true;
    }
  }


  GetFDSLevel(E2EUID, CMSUID, WSUID): number {
    if (!this.IsEmpty(E2EUID) && this.IsEmpty(CMSUID) && this.IsEmpty(WSUID))
      return 1;
    else if (!this.IsEmpty(E2EUID) && !this.IsEmpty(CMSUID) && this.IsEmpty(WSUID))
      return 2;
    else if (!this.IsEmpty(WSUID))
      return 3;
    else
      return 4;
  }
  IsEmpty(x) {
    return ((typeof x == 'undefined') || (x == null) || (x == ""));
  }

  showDisclaimerpopup() {
    this.disclaimer = true
    // this.sessionservice.setSessionStorageItem("isactive","false");
    // window.location.reload();
    if (this.exportEnabler == true) {
      if (this.envData.EnableDisclaimer == true)
        userNotification.showUserNotificationModalPopup();
      else {
        this.exportDeepdive();
      }
    }
  }

  exportDeepdive(): void {
    this.isDisabled = false;
    this.spinner.show();
    this.VersionIdMongoupdated = localStorage.getItem('VersionIdMongo')
    if (this.disclaimer == true) {
      this.disclaimer = false;
      this.iomservice.exportDeepdive(this.VersionIdMongoupdated, this.ddlabel).pipe(timeout(4800000)).subscribe(data => {
        this.blob = new Blob([data], { type: 'application/excel' });
        var downloadURL = window.URL.createObjectURL(data);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = this.ddlabel + ".xlsx";
        link.click()
        this.spinner.hide();
      },
        (err: HttpErrorResponse) => {
          this.spinner.hide();
          if (err.message != "Timeout has occurred") {
            bootbox.alert("Error occured in export deepdive!");
          }
        });
    }
  }
  NavigateAutomationPlanner() {
    var automationplannerurl;
    var clientUID = "00050000-0000-0000-0000-000000000000";
    if (this.envData.Env == 'FDS_ManualUpload') {
      automationplannerurl = this.envData.automationplannerurl + `${this.VersionId}/AIAA/${this.userType}/false`;
    }
    else if (this.envData.Env == 'SAAS_ManualUpload') {
      var E2EUId = this.sessionservice.getDeliveryConstructUId();
      if (E2EUId != null && E2EUId != '' && E2EUId != undefined) {
        automationplannerurl = this.envData.automationplannerurl + `home?E2EUID=` + E2EUId;
      }
      else {
        E2EUId = this.sessionservice.getE2EUId();
        if (E2EUId != null && E2EUId != '' && E2EUId != undefined) {
          automationplannerurl = this.envData.automationplannerurl + `home?E2EUID=` + E2EUId;
        }
      }
    }
    else {
      if (clientUID == this.sessionservice.getWSUId()) {
        automationplannerurl = this.envData.automationBlueprintManager + `null/null/${this.VersionId}/AIAA`;
      }
      else {
        automationplannerurl = this.envData.automationBlueprintManager + `${this.sessionservice.getE2EUId()}/${this.sessionservice.getWSUId()}/${this.VersionId}/AIAA`;
      }
    }
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = automationplannerurl;
    link.setAttribute('visibility', 'hidden');
    link.click();
    $(link).remove();
  }

  loadDeepdive() {
    let isSingleDD: boolean;
    this.nocallddtiles = 'false';
    this.CategorisedTicketcount = 0;
    this.CategorizedPercentage = 0;
    this.ActiveCat = null;
    this.ActiveSubcat = null;
    localStorage.setItem('CategoryId', null);
    localStorage.setItem('SubCategoryId', null);
    this.TextcategoryOrSubcategoryName = null;
    this.TextTicketCount = null;
    // if (this.envData.instanceType == 'FDS') {
    //   isSingleDD = this.DeepDiveDataFiltered.filter(x => x.Status == 'Completed' || x.Status == 'Reclassification Failed').length == 1
    // }
    // else {
    isSingleDD = this.DeepDiveDataFiltered.filter(x => (x.Status == 'Completed' || x.Status == 'No Opportunities Found' || x.DQTStatus == 'Completed')).length == 1
    //}
    this.spinner.show();
    this.TotalTicketCountLabel = 0;
    this.CategorisedTicketcount = 0;
    this.CatSubcatData = null;
    this.isLoadDeepdive = true;
    this.isLoadReview = false;
    this.isLoadTrend = false;
    this.isLoadText = false;
    this.ddFilter = true;
    this.isLoadDQT = false;
    let nooppDQT = this.sessionservice.getSessionStorageItem("nooppDQT")
    if(nooppDQT == "true"){
      this.showcharts = false;
      this.isDisabled = false;
      this.newstatus = false;
      this.newstatus1 = true;
      this.activeinactiveddtext = "No Opportunities Found";
      this.deepDivestatus = "No Opportunities Found";
    }

    // if(this.DeepDiveDataFiltered.filter(x => (x.Status == 'No Opportunities Found'))){
    //   this.isLoadDeepdive = false;
    // }
    this.GetOpportunities(false, true);
    // this.ActiveCat = 0;
    // this.ActiveSubcat = 0;
    this.magicNumber++;
    if (isSingleDD) {
      // if ($('#iomTile_' + this.VersionId).find('.view-header')[0].classList.contains('collapsed')) {
      //   $('#iomTile_' + this.VersionId).find('.view-header')[0].click();
      // }
      this.expandDD = this.VersionIdMongo;
    }
    else {
      this.expandDD = '';
    }
    // else if (!($('#iomTile_' + this.VersionId).find('.view-header')[0].classList.contains('collapsed'))) {
    //   $('#iomTile_' + this.VersionId).find('.view-header')[0].click();
    // }
    this.getKeyChartsDetails(localStorage.getItem('VersionIdMongo'));
  }

  loadReview() {
    let isSingleDD: boolean;
    this.nocallddtiles = 'false';
    // if (this.envData.instanceType == 'FDS') {
    //   isSingleDD = this.DeepDiveDataFiltered.filter(x => x.Status == 'Completed' || x.Status == 'Reclassification Failed').length == 1
    // }
    // else {
    isSingleDD = this.DeepDiveDataFiltered.filter(x => x.Status == 'Completed' || x.DQTStatus == 'Completed').length == 1
    //}    
    this.isLoadDeepdive = false;
    this.isLoadReview = true;
    this.isLoadTrend = false;
    this.isLoadText = false;
    this.ddFilter = true;
    this.isLoadDQT = false;
    let nooppDQT = this.sessionservice.getSessionStorageItem("nooppDQT")
    if(nooppDQT == "true"){
      this.showcharts = false;
      this.isDisabled = false;
      this.newstatus = false;
      this.newstatus1 = true;
      this.activeinactiveddtext = "No Opportunities Found";
      this.deepDivestatus = "No Opportunities Found";
    }
    // this.ActiveCat = 0;
    // this.ActiveSubcat = 0;
    this.magicNumber++;
    if (isSingleDD) {
      // if ($('#iomTile_' + this.VersionId).find('.view-header')[0].classList.contains('collapsed')) {
      //   $('#iomTile_' + this.VersionId).find('.view-header')[0].click();
      // }
      this.expandDD = this.VersionIdMongo;
    }
    // else if (!($('#iomTile_' + this.VersionId).find('.view-header')[0].classList.contains('collapsed'))) {
    //   $('#iomTile_' + this.VersionId).find('.view-header')[0].click();
    // }
    else {
      this.expandDD = '';
    }
  }

  loadTrend() {    
    this.nocallddtiles = 'false';
    this.isLoadDeepdive = false;
    this.isLoadReview = false;
    this.isLoadText = false;
    this.isLoadTrend = true;
    this.ddFilter = false;
    this.isLoadDQT = false;
    this.magicNumber++;
    let nooppDQT = this.sessionservice.getSessionStorageItem("nooppDQT")
    if(nooppDQT == "true"){
      this.showcharts = false;
      this.isDisabled = false;
      this.newstatus = false;
      this.newstatus1 = true;
      this.activeinactiveddtext = "No Opportunities Found";
      this.deepDivestatus = "No Opportunities Found";
    }
    // if ($('#iomTile_' + this.VersionId).find('.view-header')[0].classList.contains('collapsed')) {
    //   $('#iomTile_' + this.VersionId).find('.view-header')[0].click();
    // }
    this.expandDD = this.VersionIdMongo;
    // this.catValues = [true];
    //this.ActiveCat = 0;
    //this.ActiveSubcat = 0;
    //this.TextcategoryOrSubcategoryName = null;
    //this.TextTicketCount = null;
  }

  loadText() {    
    this.nocallddtiles = 'false';
    this.isLoadDeepdive = false;
    this.isLoadReview = false;
    this.isLoadTrend = false;
    this.isLoadText = true;
    this.ddFilter = false;
    this.isLoadDQT = false;
    let nooppDQT = this.sessionservice.getSessionStorageItem("nooppDQT")
    if(nooppDQT == "true"){
      this.showcharts = false;
      this.isDisabled = false;
      this.newstatus = false;
      this.newstatus1 = true;
      this.activeinactiveddtext = "No Opportunities Found";
      this.deepDivestatus = "No Opportunities Found";
    }
    this.magicNumber++;
    // if ($('#iomTile_' + this.VersionId).find('.view-header')[0].classList.contains('collapsed')) {
    //   $('#iomTile_' + this.VersionId).find('.view-header')[0].click();
    // }
    this.expandDD = this.VersionIdMongo;
  }

  LoadTrendOrTextAnalysis(categoryId, categoryName: string, subcatId, ticketCount: any) {
    this.sessionservice.setSessionStorageItem('nocallDDtiles', 'true');
    this.nocallddtiles = 'true';
    this.isLoadReview = false;
    this.isLoadDeepdive = false;
    this.isLoadDQT = false;
    localStorage.setItem('CategoryId', JSON.stringify(categoryId));
    localStorage.setItem('SubCategoryId', JSON.stringify(subcatId));
    this.TextcategoryOrSubcategoryName = categoryName;
    this.TextTicketCount = ticketCount;
    this.expandDD = this.VersionIdMongo;
    // localStorage.setItem('CatSubcatName', categoryName.toString());
    // localStorage.setItem('CatSubcatticketCount', ticketCount.toString());
    if (this.isLoadTrend == true) {
      this.isLoadText = false;
      this.isLoadTrend = true;
      this.ddFilter = false;
      this.ActiveCat = categoryId;
      this.ActiveSubcat = subcatId;
    }
    else if (this.isLoadText == true) {
      this.isLoadTrend = false;
      this.isLoadText = true;
      this.ddFilter = false;
      this.ActiveCat = categoryId;
      this.ActiveSubcat = subcatId;
    }
    else {
      //this.loadTrend();
      this.isLoadText = false;
      this.isLoadTrend = true;
      this.ddFilter = false;
      this.ActiveCat = categoryId;
      this.ActiveSubcat = subcatId;
    }
  }

  EditObservation(id) { // Category Id
    if (id != 0) {
      var img = $("#editicon_" + id).attr('src');
      if (img == "assets/images/edit.svg") {
        this.observationText = document.getElementById("editobserv_" + id).textContent;
        document.getElementById("editobserv_" + id).contentEditable = "true";
        $("#editicon_" + id).attr('src', 'assets/images/check-icon.svg');
      }
      if (img == "assets/images/check-icon.svg") {
        document.getElementById("editobserv_" + id).contentEditable = "false";
        $("#editicon_" + id).attr('src', 'assets/images/edit.svg');
        var editedObservation = document.getElementById("editobserv_" + id).textContent;
        this.iomservice.updateobs('', editedObservation, id, 1).subscribe(data => {
          this.spinner.hide();
          if (data == "Success") {
            document.getElementById("editobserv_" + id).contentEditable = "false";
          }
        }
          ,
          (err: HttpErrorResponse) => {
            this.spinner.hide();
            console.log("Error Occured !");
          });
      }
    }
  }

  //Reset Observation
  ResetObservation(id) {
    var img = $("#editicon_" + id).attr('src');
    if (img == "assets/images/check-icon.svg") {
      $("#editicon_" + id).attr('src', 'assets/images/edit.svg');
      document.getElementById("editobserv_" + id).contentEditable = "false";
      document.getElementById("editobserv_" + id).textContent = this.observationText;
    }
  }

  displayCalendar() {
    this.displayCal = !this.displayCal
  }
  manualUpload() {
    document.getElementById('activedd').classList.remove('active');
    document.getElementById('inactivedd').classList.remove('active');
    document.getElementById('manualUpload').classList.add('active');
    this.iomservice.isManualUpload = true;
    let e2EUID = this.sessionservice.getE2EUId();
    let cMSUID = this.sessionservice.getCMSUId();
    let wSUID = this.sessionservice.getWSUId();
    this.sessionservice.setSessionStorageItem("reUpload", "false");    
    this.router.navigate(['createdeepdive'], { queryParams: { E2EUId: e2EUID, CMSUId: cMSUID, WSUId: wSUID } });
  }

  displayFilterToggle() {
    this.loadoldFilter = true;
    this.disfilter = false;
    this.displayFilter = !this.displayFilter;
    if (this.filterEnabler == true) {
      if (this.lstFilterResponse.length == 0) {
        this.iomservice.GetDqtFilterDetails(this.VersionIdMongo).subscribe((data: any) => {
          if (data != null) {
            this.lstFilterResponse = data;
            for (var i = 0; i < this.lstFilterResponse.length; i++) {
              this.lstFilterResponse[i]["SelectDim"] = this.lstFilterResponse[i].DimensionValues;
            }
            this.lstSelectedFilterVals = this.lstFilterResponse;
            this.lstFilterResponse_pre = JSON.stringify(this.lstFilterResponse);
            this.lstSelectedFilterVals_pre = JSON.stringify(this.lstSelectedFilterVals);
          }
        });
      }
    }
    else {
      this.lstFilterResponse = [];
      for (var i = 0; i < this.lstFilterResponse.length; i++) {
        this.lstFilterResponse[i]["SelectDim"] = this.lstFilterResponse[i].DimensionValues;
      }
      this.lstSelectedFilterVals = this.lstFilterResponse;
      this.lstFilterResponse_pre = JSON.stringify(this.lstFilterResponse);
      this.lstSelectedFilterVals_pre = JSON.stringify(this.lstSelectedFilterVals);
    }
  }

  Filter() {
    // this.lstFilterResponse = JSON.parse('[{"DimensionName":"Priority","DimensionValues":[{"DimensionValue":"Critical-0"},{"DimensionValue":"High-1"}]},{"DimensionName":"AssignedGroup","DimensionValues":[{"DimensionValue":"C"},{"DimensionValue":"H"},{"DimensionValue":"a"},{"DimensionValue":"b"},{"DimensionValue":"c"},{"DimensionValue":"d"}]},{"DimensionName":"Priority5","DimensionValues":[{"DimensionValue":"Critical"},{"DimensionValue":"High"},{"DimensionValue":"Medium"}]}]');
    this.lstFilterResponse = [];
    this.iomservice.GetDqtFilterDetails(this.VersionIdMongo).subscribe((data: any) => {
      if (data != null) {
        this.lstFilterResponse = data;
        for (var i = 0; i < this.lstFilterResponse.length; i++) {
          this.lstFilterResponse[i]["SelectDim"] = this.lstFilterResponse[i].DimensionValues;
        }
        this.lstSelectedFilterVals = this.lstFilterResponse;
        this.lstFilterResponse_pre = JSON.stringify(this.lstFilterResponse);
        this.lstSelectedFilterVals_pre = JSON.stringify(this.lstSelectedFilterVals);
      }
    },
      (err: HttpErrorResponse) => {
      });
  }

  applySelectedFilteredValues() {
    this.lstFilterResponse_pre = JSON.stringify(this.lstFilterResponse);
    this.lstSelectedFilterVals_pre = JSON.stringify(this.lstSelectedFilterVals);
    this.ClearFiltersFlag = false;
    if (this.lstFilterResponse.length > 0) {
      let dimArray: any = [];      
      let filterKeys = '';
      this.lstFilterResponse.forEach(element => {
        var dimVals;
        var dimName;
        var finalDimValues;
        this.lstSelectedFilterVals.forEach(selElement => {
          if (selElement.DimensionName == element.DimensionName) {
            let dimvalArray = [];
            dimName = selElement.DimensionName.trim();            
            if (selElement.SelectDim && selElement.SelectDim.length > 0){              
              for (let i = 0; i < selElement.SelectDim.length; i++) {
                dimVals = selElement.SelectDim[i].DimensionValue;
                if (dimName != '' && dimVals != '' && dimVals != undefined) {                                   
                  dimvalArray.push(dimVals);
                }
              }
            }
            else {
              dimVals = selElement.DimensionValue;
              if (dimVals != '' && dimVals != undefined)
              dimvalArray.push(dimVals);
            }

            finalDimValues = {
              DimensionName: dimName,
              DimensionValueList: dimvalArray
            };
            dimArray.push(finalDimValues);
          }
        });
        if (dimName != '') {
          if (filterKeys != '') {
            filterKeys = filterKeys + ',';
          }
          filterKeys = filterKeys.concat(dimName);
        }
      });
      //console.log(dimArray);
      this.DQTFilterDetails = dimArray;
      if (this.DQTFilterDetails.length == 0) {
        this.Validate();
        return;
      }
      else {
        this.GetOpportunities(true, true, true);
        this.filterPopupId.nativeElement.classList.remove('show');
        this.getKeyChartsDetails(localStorage.getItem('VersionIdMongo'));
        this.activefilter = true;
        this.displayFilter = false;
        this.loadoldFilter = false;

      }

      this.DQTFilterKeys = filterKeys.replace(/,\s*$/, "");
    }
    // this.getKeyChartsDetails(+localStorage.getItem('VersionId'));
    // this.GetOpportunities(true, true, true);
    //this.Filter();
    //this.activefilter == true;
  }

  onItemSelect(dropdownName: string, dropdownValue: string) {

    //this.selectedDimValues = { [dropdownName]: dropdownValue };
    this.IsFilterModified = true;
    let element: { DimensionName: string, DimensionValue: string };
    element = {
      DimensionName: dropdownName,
      DimensionValue: dropdownValue
    }
    this.lstSelectedFilterVals.push(element);

    //console.log('onItemSelect', this.lstSelectedFilterVals);
  }
  onSelectAll(dropdownName: string, dropdownValue: any) {
    this.IsFilterModified = true;
    var that = this, newSelectedList = [];
    this.lstSelectedFilterVals.forEach(function (selElement, index) {
      if (selElement.DimensionName != dropdownName) {
        newSelectedList.push(selElement);
      }
    });
    if (newSelectedList.length > 0) {
      this.lstSelectedFilterVals = newSelectedList;
    }
    else {
      this.lstSelectedFilterVals = [];
    }
    for (let i = 0; i < dropdownValue.length; i++) {
      let element: { DimensionName: string, DimensionValue: string };
      element = {
        DimensionName: dropdownName,
        DimensionValue: dropdownValue[i].DimensionValue
      }
      that.lstSelectedFilterVals.push(element);
    }
    //console.log('onSelectAll', this.lstSelectedFilterVals);
  }
  onItemDeSelect(dropdownName: string, dropdownValue: string) {
    this.IsFilterModified = true;
    let element: { DimensionName: string, DimensionValue: string };
    element = {
      DimensionName: dropdownName,
      DimensionValue: dropdownValue
    }
    var that = this;;
    this.lstSelectedFilterVals.forEach(function (selElement, index) {
      if (selElement.DimensionName == dropdownName && selElement.DimensionValue == dropdownValue) {
        that.lstSelectedFilterVals.splice(index, 1);
      }
      else if (selElement.DimensionValues.length > 0) {
        for (let i = 0; i < selElement.DimensionValues.length; i++) {
          if (selElement.DimensionName == dropdownName && selElement.DimensionValues[i].DimensionValue == dropdownValue) {
            selElement.DimensionValues.splice(index, i);
          }
        }
      }
      else {
        // Do nothing 
      }
    });
    // this.lstDeSelectedFilterVals.push(element);
    //console.log('onItemDeSelect', this.lstSelectedFilterVals);
  }
  onItemDeSelectAll(dropdownName: string, dropdownValue: any) {
    this.IsFilterModified = true;
    var that = this, newSelectedList = [];
    if (dropdownValue != null) {
      this.lstSelectedFilterVals.forEach(function (selElement, index) {
        if (selElement.DimensionName != dropdownName) {
          //that.lstSelectedFilterVals.splice(index, 1);
          newSelectedList.push(selElement);
        }
      });
      if (newSelectedList.length > 0) {
        this.lstSelectedFilterVals = newSelectedList;
      }
      else {
        this.lstSelectedFilterVals = [];
      }
      //console.log('onDeSelectAll', this.lstSelectedFilterVals);
    }
    else {
      this.lstSelectedFilterVals = [];
    }
  }
  clearAllFilters() {
    this.Filter();
    this.ClearFiltersFlag = true;
    this.DQTFilterDetails = [];
    this.activefilter = false;
    if (this.isLoadDeepdive)
      this.GetDeepDiveDetails(this.DeepDiveDetails);
    //this.filterPopupId.nativeElement.classList.remove('show');
    // this.dropdownSettings.clearSearchFilter=true;
    //this.lstSelectedFilterVals = [];
    //$(".multiselect-item-checkbox input:checkbox").prop("checked", false);

    //this.onItemDeSelectAll(null,null);
    //$(".multiselect-dropdown .selected-item").remove();
    //$(".multiselect-dropdown.ng-star-inserted").remove();
    // this.lstSelectedFilterVals = [];

  }
  Validate() {

    bootbox.alert("Please select any one filter");
    return false;
  }

  clearAll(event: any) {
    if (event) {
      this.Filter();
      // this.filterPopupId.nativeElement.classList.remove('show');
    }
  }
  cancelFilterPopup() {
    this.lstFilterResponse = JSON.parse(this.lstFilterResponse_pre);
    this.lstSelectedFilterVals = JSON.parse(this.lstSelectedFilterVals_pre);
    this.displayFilter = false;
    this.loadoldFilter = false;
  }

  getKeyChartsDetails(versionid) {
    this.keyChartGraphData = null;
    let CategoryId = null;
    let SubCategoryId = null;
    this.rowRankwiseDataKey = null;
    this.keyChartTitleList = null;
    if (this.keyChartsRowrankings.length > 0) {
      // if (this.subCategoryId != 0 && this.subCategoryId != null) {
      //   CategoryId = this.categoryId == undefined ? '' : this.categoryId;
      //   SubCategoryId = this.subCategoryId == undefined ? '' : this.subCategoryId;
      //   this.isExpend = false;
      // }
      // else if (this.categoryId != 0 && this.categoryId != null) {
      //   CategoryId = this.categoryId == undefined ? '' : this.categoryId;
      //   SubCategoryId = '';
      //   this.isExpend = false;
      // }
      //else {
      CategoryId = null;
      SubCategoryId = null;
      // this.isExpend = true;
      //}
      this.loadKeystandardcharts(CategoryId, SubCategoryId, versionid);
    }
  }

  async loadKeystandardcharts(CategoryId, SubCategoryId, versionid) {
    let data: any;
    data = await Promise.all(this.keyChartsRowrankings.map(x => this.iomservice.LoadStandardCharts(versionid, CategoryId, SubCategoryId, x, 10, this.DQTFilterDetails, this.IsFilterModified)));
    data.forEach(element => {
      this.rowRankwiseDataKey = { ...this.rowRankwiseDataKey, ...element.SeverityData };
      if (Object.values(this.rowRankwiseDataKey).length > 0) {
        this.keyChartGraphData = this.createObj(this.rowRankwiseDataKey);
        this.NoDataKey = false;
      }
      else {
        this.NoDataKey = true;
      }
    });
  }
  createObj(data) { //scData, graphData) {
    let result = {};
    // let arr = [...Object.keys(scData)] //.concat(Object.keys(obj1))];
    // arr.forEach((v, i) => {
    //   result['A' + v] = scData[v];
    // });
    let arr1 = [...Object.keys(data)] //.concat(Object.keys(obj1))];
    if (true) {
      arr1.forEach((v, i) => {
        let isForecast = Object.keys(data[v])[0] == 'forcast';
        if (isForecast) {
          //result['B' + v] = data[v];
          result['A' + v] = data[v];
        }
        else {
          //result['C' + v] = data[v];
          result['B' + v] = data[v];
        }
      });
    }
    else {
      arr1.forEach((v, i) => {
        result['A' + v] = data[v];
      });
    }
    return result;
  }
  GetRowRank(key, IsSpliceRequired): number {
    if (IsSpliceRequired) {
      key = key.slice(1);
    }
    return parseInt((key.indexOf(':|:') > -1 ? key.split(':|:')[1] : 0));
  }
  GetChartTitle(key) {
    let rowRank = 0;
    rowRank = this.GetRowRank(key, true);
    if (rowRank == 10005) {
      return "Total Ticket By Application Name";
    }
    else if (rowRank == 10006) {
      return "Total Ticket By SupportGroup Name";
    }
    else {
      return "";
    }
  }
  changeSeletion() {
    this.getKeyChartsDetailsForExpenedView(this.topSelection);
  }
  formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  redirectToAutomation(categoryId: string) {
    this.iomservice.CategoryIDForRedirection = categoryId;
    this.magicNumber++;
    this.isLoadTrend = false;
    this.isLoadDeepdive = false;
    this.isLoadReview = true;
    this.isLoadText = false;
    this.ddFilter = true;
    this.isLoadDQT = false;
  }
  over(catId) {
    document.getElementById('categorylink_' + catId).style.color = "#004DFF";
  }
  out(catId) {
    document.getElementById('categorylink_' + catId).style.color = "#5A5A5A";
  }
  getKeyChartsDetailsForExpenedView(topSelection) {
    this.spinner.show();
    this.keyChartGraphDataExpended = null;
    let CategoryId = null;
    let SubCategoryId = null;
    if (this.keyChartsRowrankings.length > 0) {

      CategoryId = null;
      SubCategoryId = null;
      this.iomservice.LoadKeyInsightsCharts(this.VersionIdMongo, CategoryId, SubCategoryId, 10005, topSelection, this.DQTFilterDetails, this.IsFilterModified).pipe(timeout(5400000)).subscribe((data: any) => {
        this.spinner.hide();
        if (data != null) {
          this.keyChartGraphDataExpended = this.createObj(data.SeverityData);
        }
      },
        (err: HttpErrorResponse) => {
          this.spinner.hide();
          console.log('Error Occured !');
        });
    }
  }
  onClickedOutside(e: Event) {
    if ($(e.target).attr('ngbdatepickerdayview') == undefined)
      this.displayCal = false;
  }
  onClickedOutsideFilter(e: Event) {
    this.displayFilter = false;
  }
  clickStatusFilter() {
    this.displayCal = false;
    this.displayFilter = false;
  }
  clickeSearchFilter() {
    this.displayCal = false;
    this.displayFilter = false;
  }

  GetDonutTicketDetail() {
    var SelectedLanguage = this.sessionservice.getSessionStorageItem('SelectedDDLanguage');
    var SelectedLanguageEdit = this.sessionservice.getSessionStorageItem('SelectedLanguage');
    if(SelectedLanguage==null || SelectedLanguage==undefined || SelectedLanguage=='' || SelectedLanguage=='null')
  {
    SelectedLanguage='All';
  }
  else if(SelectedLanguageEdit!=null && SelectedLanguageEdit!=undefined)
  {
    if(!SelectedLanguageEdit.includes('|'))
    {
      SelectedLanguage='All';
    }
  }
    this.iomservice.GetFilteredTicketCount<any>(this.VersionIdMongo,SelectedLanguage, this.userType, this.DQTFilterDetails).subscribe(data => {    
      if (data) {
        this.loadDoughnut = true;
        if(data.TotalTicketcount == 0 && data.CategorisedTicketcount ==0)
        {
          this.loadDoughnut = false;
        }
        this.TotalTicketCountLabel = data.TotalTicketcount;
        this.CategorisedTicketcount = data.CategorisedTicketcount;
        this.CategorizedPercentage = Math.floor((data.CategorisedTicketcount / data.TotalTicketcount) * 100);
        this.DDStartDate = data.DDDetails.StartDate;
        this.DDEndDate = data.DDDetails.EndDate;
         //set visibility based on TicketType value
         if(data.DDDetails.TicketType == '' || data.DDDetails.TicketType == null)
         {
           this.showDDTicketType = false;
         }
         else
         {
           this.showDDTicketType = true;
         }
        this.DDTicketType = data.DDDetails.TicketType
        this.DDClassificationBasedOn = data.DDDetails.ClassificationBasedOn;
        this.DDAlgorithm = data.DDDetails.Algorithm
      }
    }, (err: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  loadDQT() {         
    this.showcharts = true;
    this.isDisabled = false;
    this.newstatus = false;
    this.newstatus1 = false;
    this.deepDivestatus = "Completed";    
    this.nocallddtiles = 'false';    
    this.isLoadDeepdive = false;
    this.isLoadReview = false;
    this.isLoadTrend = false;
    this.isLoadText = false;
    this.ddFilter = false;
    this.magicNumber++;
    this.expandDD = this.VersionIdMongo;
    this.isLoadDQT = true;
    if(this.ActiveCat != '' || this.ActiveSubcat != ''){
      this.ActiveCat = null;
      this.ActiveSubcat = null;
      this.TextcategoryOrSubcategoryName = null;
      localStorage.removeItem('CategoryId');
      localStorage.removeItem('SubCategoryId');
      this.getKeyChartsDetails(this.VersionIdMongo)
    }
  }

  ReUploadFile(child: any){ 
    if(this.envData.Env == "FDS_ManualUpload"){
      this.manualUpload();
    }
    else{
      this.navigateToCreatedeepdive();
    }
    this.sessionservice.setSessionStorageItem("reUpload", "true");
    this.sessionservice.setSessionStorageItem("reUploadversionID", child.VersionIdMongo);   
  }

  GetSelectedLanguage(item: any) {
    this.spinner.show();
    this.sessionservice.setSessionStorageItem("SelectedDDLanguage", item.target.value);
    // this.selectedStdLanguage=item;
    this.GetDeepDiveDetails(this.DeepDiveDetails);
  }
  
 
  setDDLanguage() {
    var SelectedLanguage = this.sessionservice.getSessionStorageItem('SelectedLanguage');
    var SelectedDDLanguage = this.sessionservice.getSessionStorageItem('SelectedDDLanguage');
    if(SelectedDDLanguage==null || SelectedDDLanguage==undefined || SelectedDDLanguage== '' || !SelectedLanguage.includes(SelectedDDLanguage))
    {
      if (SelectedLanguage.includes('|')) {
        this.selectedStdLanguage = 'All';
      }
      else {
        this.selectedStdLanguage = SelectedLanguage;
        this.sessionservice.setSessionStorageItem("SelectedDDLanguage", SelectedLanguage);
      }
    }
    else{
      this.selectedStdLanguage = SelectedDDLanguage;
    }
    if(SelectedLanguage!=null && SelectedLanguage!=undefined)
    {
      this.isDisabledLanguage = false;
    if(SelectedLanguage.includes('|'))
    {
      this.dropdownSettingsLanguage = {
        // singleSelection: false,
        idField: 'DimensionValue',
        textField: 'DimensionValue',
        itemsShowLimit: 2,
        // limitSelection : 2,
        allowSearchFilter: false
      };
      this.LanguageList = [];
      this.LanguageList.push('All');
      var tempLanguageList= SelectedLanguage.split('|');
      for (var i = 0; i < tempLanguageList.length; i++) {
        if(!(this.LanguageList.toString().includes(tempLanguageList[i]))){
          this.LanguageList.push(tempLanguageList[i]);
        }        
      }
    }
    else{
      this.isDisabledLanguage = true;
      this.dropdownSettingsLanguage = {
        // singleSelection: false,
        idField: 'DimensionValue',
        textField: 'DimensionValue',
        itemsShowLimit: 2,
        limitSelection : 2,
        allowSearchFilter: false
      };
  
      this.LanguageList = [];
      // this.LanguageList.push('All');
      this.LanguageList.push(SelectedLanguage);
    }
    }
    if(this.dqtAutomate==false)
    {
      this.isDisabledLanguage = true;
    }
  }
  LoadNewProposalScope(proposalId: any) {
    this.spinner.show();
    this.iomservice.getProp<any>(this.sessionservice.getUserName(), "").subscribe(data => {
      this.spinner.hide();
      this.sessionservice.setSessionStorageItem("ProposalData", JSON.stringify(data))
      this.sessionservice.setDeliveryConstructUId(proposalId.toString());  
      this.messageService.loadHeader(proposalId);  
      // this.router.navigate(['deepdive']);
  
    },
      (err: HttpErrorResponse) => {
        console.log("Error Occured !");
        this.spinner.hide();
      });
  }


}

